/** - Este Script se encarga de hacer funcionar toda la parte del mapa relacionada con
 * Open Layers, la version de Open Layers que se uso a la hora de escribir esto fue la 6.x
 * @author Maki Parodi - IGM (Sección: SIG)
 */

import $, { map } from "jquery";
//#region Imports y Requiere
// import 'ol/ol.css';

//se usa para imprimir
import html2canvas from 'html2canvas';

//se usa para interpretar Config.JSON
import {ConfigJSON} from './Config'

import Map from 'ol/Map';
import View from 'ol/View';

import {DragAndDrop, Draw, Modify, Snap, Select, defaults as defaultInteractions, Extent,} from 'ol/interaction';
import {Circle as CircleStyle, Fill, Stroke, Style} from 'ol/style';
import {GPX, GeoJSON, IGC, KML, TopoJSON, GML} from 'ol/format';
import GeoTIFF from 'ol/source/GeoTIFF';

import {Layer, VectorImage as VectorImageLayer} from 'ol/layer';
import {Vector as VectorLayer} from 'ol/layer';

import TileLayer from 'ol/layer/Tile';
import ImageLayer from 'ol/layer/Image';
import * as olExtent from 'ol/extent';
import { OSM, Vector as VectorSource} from 'ol/source';
import TileWMS from 'ol/source/TileWMS';
import ImageWMS from 'ol/source/ImageWMS';

import boundingExtent from 'ol/extent';
import {extend} from 'ol/extent';

//necesarios para poder ver las coordenadas del mouse
import MousePosition from 'ol/control/MousePosition';
import RotateControl from 'ol/control/Rotate';
import {createStringXY, toStringXY} from 'ol/coordinate';
import {defaults as defaultControls, Rotate} from 'ol/control';
import format from 'ol/coordinate';

//para re projectar
import Graticule from 'ol/layer/Graticule';
import proj4 from 'proj4';
import {get as getProjection} from 'ol/proj';
import {getTransform} from 'ol/proj';
import {applyTransform} from 'ol/extent';
import {register} from 'ol/proj/proj4';
import {transformExtent} from 'ol/proj';
import {transform} from 'ol/proj';
//

//controls
import Zoom from 'ol/control/Zoom';
import ZoomSlider from 'ol/control/ZoomSlider';
import Attribution from 'ol/control/Attribution'
import ScaleLine from 'ol/control/ScaleLine';
import { preventDefault } from "ol/events/Event";
//

//Para poder medir se necesitan estos imports
import Overlay from 'ol/Overlay';
import {LineString, Polygon} from 'ol/geom';
import {getArea, getLength} from 'ol/sphere';
import {unByKey} from 'ol/Observable';
import { collapseTextChangeRangesAcrossMultipleVersions } from "typescript";
//
let w = /** @type {ExtendedWindow} */ (window);

//Config
var Configuration = require('./json/Config.xml');

/**
 * @type {ConfigJSON} - tiene los datos de las opciones del visualizador
 */
var ConfigurationJSON = require('./json/Config.json');

document.getElementById("OLControlsCSS").disabled = false;
// document.getElementById("PrintSetings").disabled = true;
//#endregion

//variable que contendra la view del mapa de forma global, necesaria para ciertos procesos
w.GlobalMapView;

//#region CLASES

  //objeto declarado que contendra los datos para reinicializar la view
  w.CustomeView = class CustomeView {
    constructor(projection, center, zoom, minZoom, maxZoom) {
      this.projection = projection;
      this.center = center;
      this.zoom = zoom;
      this.minZoom = minZoom;
      this.maxZoom = maxZoom;
    }
  }

  w.GlobarlLayerID = 0;
  w.GlobarlLayerOLNumberName = 0;

  //objeto que tendra los datos de la capa
 /** Clase LayerData, tiene todos los datos extras necesarios para la interface sobre las Capas del mapa
 *
*/
class LayerData {

  /**
   * @constructor
   * @param {Object} parametros - Opriones con las que se crear la Ventana
   * @param {number} parametros.id - id de la capa, es unico por capas e irrepetible
   * @param {boolean} parametros.Visible - Si la capa esta visible
   * @param {string} parametros.Nombre - Nombre de la capa
   * @param {string} parametros.Formato - Formato de la capa ("WMS, OL, GeoJSON, KML o BaseMap")
   * @param {HTMLelement} parametros.GUILayer - HTMLElement de la capa que la representa en la interface
   * @param {Layer} parametros.OpenLayerSource - Layer de OpenLayer Asociada a esta capa
   * @param {boolean} parametros.Listado - Si la capa ya esta listada en la interface, se usa para control
   * @param {number} parametros.Opacacity - Opacasicad en numero, 0 transparente, 1 visible completamente
   * @param {boolean} parametros.CapaPreCargada - Valor que indica si esta capa es precargacda, esto proboca que la misma no sea eliminable
   * @param {string} parametros.Metadata - Metadatos de la capa
   * @param {string} parametros.EstadoDeLaCapa - Estado de la capa representado en texto, Ej "editando" o "eliminado"
   * @param {boolean} parametros.CapaDescargable - Si la capa sera descargable o no (para la funcion copiar WMS al protapapeles)
   * @param {string} parametros.Attributions - Atributions en formato HTML text Ej "<a href="link">Link</<>"
   * @param {BoundingBox} parametros.BoundingBox - BoundingBox dela capa, contiene el sistema de referencia y las coordenadas de las esquinas opuestas de la bounding box
   * @param {string[]} parametros.LayerTitles - Lista de los titulos de las capas que conforma la capa (Solo WMS)
   * @param {string[]} parametros.LayerNames - Lista de los nombres de las capas que conforma la capa (Solo WMS)
   */
  // @param {{id: number, Visible: boolean, Nombre: string, Formato: string, GUILayer: HTMLElement, OpenLayerSource: Layer, Listado: boolean, Opacacity: number, CapaPreCargada:boolean, Metadata: string, EstadoDeLaCapa: string, CapaDescargable: boolean, Attributions: HTMLElement, LayerTitles: string[], LayerNames: string[] }} parametros

  constructor(parametros) {
      this.id = w.GlobarlLayerID;
      w.GlobarlLayerID++;
      this.Visible = parametros.Visible;
      this.Nombre = parametros.Nombre;
      this.Description = parametros.Description;
      this.Formato = parametros.Formato;
      this.GUILayer = parametros.GUILayer;
      this.OpenLayerSource = parametros.OpenLayerSource;
      this.Listado = parametros.Listado;
      this.Opacacity = parametros.Opacacity;
      this.CapaPreCargada = parametros.CapaPreCargada;
      this.Metadata = parametros.Metadata;
      this.EstadoDeLaCapa = parametros.EstadoDeLaCapa;
      this.CapaDescargable = parametros.CapaDescargable;
      this.Attributions = parametros.Attributions;
      this.BoundingBox = parametros.BoundingBox;
      if(parametros.LayerTitles != undefined && parametros.LayerTitles != null){
        this.LayerTitles = parametros.LayerTitles;
        this.LayerNames = parametros.LayerNames;
      }
  }

  setDescargable(value){
    this.CapaDescargable = value;
  }

  /** - Setea la extencion de la capa
   * @param {Object} Extent
   * @param {string} Extent.CRS  - CRS del bounding box
   * @param {number} Extent.XMin - Coordenadas en X de la esquina SE
   * @param {number} Extent.YMin - Coordenadas en Y de la esquina SE
   * @param {number} Extent.XMax - Coordenadas en X de la esquina NO
   * @param {number} Extent.YMax - Coordenadas en Y de la esquina NO
   */
  SetExtent(Extent){
    if(this.BoundingBox == undefined){
      this.BoundingBox = new BoundingBox();
    }
    this.BoundingBox.CRS = Extent.CRS
    this.BoundingBox.XMin = Extent.XMin
    this.BoundingBox.YMin = Extent.YMin
    this.BoundingBox.XMax = Extent.XMax
    this.BoundingBox.YMax = Extent.YMax
  }

  /** - devuelve extent procesado para ol con las coordenadas en el formato array ya transformadas al crs del mapa actual
   * @returns - devuelve la extension en formato [XMin, YMin, XMax, YMax] ya transformadas
   */
  GetExtentTransformed(){

    if(this.BoundingBox != undefined){
      let extencion = this.BoundingBox.GetExtencion();
      let layerCRS = this.BoundingBox.GetCRS();
      let mapCRS = GlobalMapView.getProjection().getCode();

      let extenTransformed = transformExtent(extencion, layerCRS, mapCRS);
      return extenTransformed
    }else{
      return undefined;
    }
  }
}


w.LayerDataGetTitleByName = function(nombre, LayerData){
  var layerNames = LayerData.LayerNames;
  var indice = layerNames.indexOf(nombre);

  return LayerData.LayerTitles[indice];
}

/** Clase ResultLayerGetInfo, tiene todos los resultados de la consulta de pedir informacion
 */
 class ResultLayerGetInfo{
  /**
   * @constructor
   * @param {Object} valores - Opriones con las que se crear la Ventana
   * @param {string} valores.Nombre - Nombre de la capa
   * @param {string} valores.Title - Titulo de la capa
   * @param {string[]} valores.Fields - Lista de los campos de la tabla
   * @param {string[]} valores.Values - Lista de los valores de los campos de la tabla
   * @param {string} valores.ServerType - Tipo de servidor
   */
  constructor(valores){
    if(valores != null && valores != undefined){
      this.Nombre = valores.Nombre
      this.Title = valores.Title
      this.Fields = valores.Fields
      this.Values = valores.Values
      this.ServerType = valores.ServerType
    }

  }
}

  //CLASS BOUNDING BOX
  /** - BoundingBox
   *  @param {string} CRS  - CRS del bounding box
   */
  class BoundingBox {
    /**
     * @param {string} CRS  - CRS del bounding box
     * @param {number} XMin - Coordenadas en X de la esquina SE
     * @param {number} YMin - Coordenadas en Y de la esquina SE
     * @param {number} XMax - Coordenadas en X de la esquina NO
     * @param {number} YMax - Coordenadas en Y de la esquina NO
     */
    constructor(CRS, XMin, YMin, XMax, YMax) {
      this.CRS = CRS;
      this.XMin = XMin;
      this.YMin = YMin;
      this.XMax = XMax;
      this.YMax = YMax;
    }

    /** - devuelve el CRS de la bounding box en formato EPSG:CODE
     * @returns {string}
     */
    GetCRS(){
      if(this.CRS == "CRS:84"){
        return "EPSG:4326"
      }else{
        return this.CRS;
      }
    }

    /** - devuelve la extension en formato [XMin, YMin, XMax, YMax]
     * @returns {[number]}
     */
    GetExtencion(){
      //console.log("returning " + [this.XMin, this.YMin, this.XMax, this.YMax]);
      return[this.XMin, this.YMin, this.XMax, this.YMax]
    }

    ToString(){
      return "(CRS:\"" + this.CRS + "\" |XMin: " + this.XMin + " YMin: " + this.YMin + " XMax: " + this.XMax + " YMax: " + this.YMax + "|)";
    }
  }

//#endregion

//inicializo el mapa en null para poder detectar cuando deje de serlo
w.map == null;
w.unidadesDeLaProyeccion = "km_adaptive";

//#region GlobalDefaultMapView
  //objeto instainciado que contendra los datos para reinicializar la view
  w.GlobalDefaultMapView = new w.CustomeView(
    /*projection:*/ 'EPSG:3857',
    /*center:*/ [ -6557200, -8903000],
    /*zoom:*/ 15.671940828453282,
    /*minZoom:*/ 0,
    /*maxZoom:*/ 21.32 );

    //uruguay
    // w.GlobalDefaultMapView = new w.CustomeView(
    //   /*projection:*/ 'EPSG:3857',
    //   /*center:*/ [-6200000, -3820000],
    //   /*zoom:*/ 6.9,
    //   /*minZoom:*/ 0,
    //   /*maxZoom:*/ 19 );

  //default WorldExtent, se actualizara con los cambios de proyeccion
  w.ActualProjectionWorldExtent;

//#endregion

//#region variables globales utilizando el componente w

//#region CLASS LayersDelMapa y sus funciones

  //array donde estaran los datos de las capas en formato LayerData
  w.layersDelMapa = class LayersDelMapa{
      constructor(Lista) {
        this.Lista = Lista;
      }
  };

  //agrega un LayerData al la lista de (LayerData)s
  w.layersDelMapa.AddLayerToMap = function(LayerData){
      //layersDelMapa.Lista.push(LayerData);
      w.layersDelMapa.Lista.splice(0,0,LayerData)
      //w.layersDelMapaGUI.CreateHTMLElementForLayerData(layerToAdd)
      //w.layersDelMapa.ActualizarZIndex()
  }

  //cambia la capa en la posicionOriginal a la posicionNueva
  w.layersDelMapa.ChangeLayerPosition = function(posicionOriginal, posicionNueva){
    //console.log("muving capa from " + posicionOriginal + " to " + posicionNueva)
    if(posicionOriginal != posicionNueva){
      let elementoQuitado =  w.layersDelMapa.Lista.splice(posicionOriginal, 1)
      w.layersDelMapa.Lista.splice(posicionNueva, 0, elementoQuitado[0])

      w.layersDelMapa.ActualizarZIndex();
    }
  }

  //actualiza la posicion de todas las capas del mapa con las nuevas
  w.layersDelMapa.ActualizarZIndex = function(){
    for(var capaAActualizar = 0; capaAActualizar < w.layersDelMapa.Lista.length; capaAActualizar++){
      w.layersDelMapa.Lista[capaAActualizar].OpenLayerSource.set('zIndex', capaAActualizar * -1)
      w.layersDelMapa.Lista[capaAActualizar].GUILayer.id = capaAActualizar + "-"
    }
  }

  //crea una capa vacia y la agrega al mapa, con el nombre del parametro
  w.layersDelMapa.CreateEmptyLayer = function( NombreDeLaCapa ){
    var vectorSource = new VectorSource({
    });

      var layer = new VectorLayer({
        className: w.GlobarlLayerOLNumberName,
        zIndex: w.map.getLayers().getArray().length *-1,
        source: vectorSource,
        style: w.defaultSymbol,
      });

      //subimos el contador de nombre
      w.GlobarlLayerOLNumberName++;

      w.map.addLayer(layer);
      var metadatos = {
        Origen: "Creada en el visualizador (OL)",
      };

      //var layerToAdd = new LayerData(0,true, NombreDeLaCapa , "OL", w.map.getLayers().getArray()[ w.map.getLayers().getArray().length -1], false, 1, metadatos, "", '');

      var layerToAdd = new LayerData({
      //datos de la layer a agregar
        //zDepth: 0,
        Visible: true,
        Nombre: NombreDeLaCapa,
        Description: "Capa Virtual alojada en el navegador, creada en el Visualizador Antartida SIGAUy del IGM.",
        Formato: "OL",
        OpenLayerSource: w.map.getLayers().getArray()[ w.map.getLayers().getArray().length -1],
        Listado: false,
        Opacacity: 1,
        CapaPreCargada: false,
        Metadata: metadatos,
        EstadoDeLaCapa: "",
        CapaDescargable: false,
        Attributions: "",
      });

      layerToAdd.OpenLayerSource.OriginalName = NombreDeLaCapa;

      //w.layersDelMapa.Lista.push( layerToAdd );
      w.layersDelMapa.Lista.splice(0,0,layerToAdd)

      w.layersDelMapaGUI.CreateHTMLElementForLayerData(layerToAdd)

      w.layersDelMapa.ActualizarZIndex()
      //constructor(ZDepth, Visible, Nombre, Formato, OpenLayerSource, Listado, Opacacity, CapaPreCargada, Metadata, EstadoDeLaCapa
  }

  //agrega la capa como wms con los datos de los parmetros
  //esto solo se usa para cuando se agregan por el usuario
  w.layersDelMapa.AddLayerFromWMS = function(WMSUrl, Layers, Format){

    // console.log("w.layersDelMapa.AddLayerFromWMS( " + WMSUrl + ", " + JSON.stringify(Layers) + ", " + Format + ")")
    //console.log(Layers)

    var Extension = [0,0,0,0];

    // console.log("cargando capa WMS");
    // console.log(WMSUrl);
    // console.log(Layers);
    // console.log(Format);
    // console.log(Layers.length);

    var LayerNames = [];
    var LayerTitles = [];
    var LayerBBox = [];
    var Descriptions = [];
    let descriptionString = "<div>"

    for(var LayerActual = 0; LayerActual<Layers.length; LayerActual++){
      Descriptions.push(w.XMLGetLayerDescription(Layers[LayerActual]));
      LayerNames.push( w.XMLGetLayerName(Layers[LayerActual]) );
      LayerTitles.push( w.XMLGetLayerTitle(Layers[LayerActual]) );
      LayerBBox.push(w.XMLGetBoundingBoxSRS(Layers[LayerActual]) );
    }

    // console.log("LayerNames")
    // console.log(LayerNames)
    // console.log("LayerTitles")
    // console.log(LayerTitles)
    // console.log("LayerBBox");
    // console.log(LayerBBox)
    // console.log("Descriptions");
    // console.log(Descriptions)

    var NombreDeLaCapa = "";
    if(Layers.length > 1){
      //si hay mas de una capa
      if(Layers.length > 2){
        NombreDeLaCapa = "Grupo WMS: ";
        NombreDeLaCapa += LayerTitles[0] + ", ";
        NombreDeLaCapa += LayerTitles[1] + "...(" + ((Layers.length)-2) + " mas)";
      }else{
        NombreDeLaCapa = "Grupo WMS: ";
        NombreDeLaCapa += LayerTitles[0] + ", ";
        NombreDeLaCapa += LayerTitles[1];
      }

      //armando descripciones:
      for( let index = 0; index < Layers.length; index++){
        descriptionString += `
          <span class="W_Layer_NOT_Loaded"> - (WMS Abstract)</span>
          <span> ${LayerTitles[index]} </span>
          <br />
          <span> ${Descriptions[index]} </span>
          `;

        if(index < Layers.length-1){
          descriptionString += `<br /><br />`
        }
      }

      descriptionString +=`</div>`;

      //voy a combinar todos los BBox de los WMS seleccionados
      // console.log("tratando de combinar los Bounding boxes");
      var boundingBoxToUse = XMLGetCombinedBoundingBox(LayerBBox);

      // console.log("Listo bounding boxes combinados");

    }else{
      //si solo hay una
      NombreDeLaCapa = LayerTitles[0];
      var boundingBoxToUse = LayerBBox[0]
      descriptionString += `
        <span class="W_Layer_NOT_Loaded"> - (WMS Abstract)</span>
        <br />
        <span> ${Descriptions[0]} </span>
        </div>
        `;
    }

    // console.log("boundingBoxToUse");
    // console.log(boundingBoxToUse);

    // console.log("transformation")
    // console.log("transformExtent("+JSON.stringify(boundingBoxToUse.GetExtencion())+", "+"EPSG:4326"+", "+JSON.stringify(GlobalMapView.getProjection().getCode()) );
    // console.log(transformExtent(boundingBoxToUse.GetExtencion(), "EPSG:4326", GlobalMapView.getProjection().getCode()));

    var NuevaCapaWMS = new TileLayer({
      className: w.GlobarlLayerOLNumberName,
      preload: Infinity,
      zIndex: w.map.getLayers().getArray().length * -1,
      // function boundingExtent(coordinates: format.Coordinate[]): olExtent.Extent
      //ESTO ESTA FALLADO, REVISAR LOGICA
      extent: transformExtent(boundingBoxToUse.GetExtencion(), "EPSG:4326", GlobalMapView.getProjection().getCode()), //transformExtent(boundingBoxToUse.GetExtencion(), boundingBoxToUse.GetCRS(), GlobalMapView.getProjection()),
      source: new TileWMS({
        url: WMSUrl,
        params:{
          LAYERS: LayerNames,
          FORMAT: Format,
          TRANSPARENT: true
        },
        crossOrigin: 'anonymous'
      })
    });

  //subimos el contador de nombre
    w.GlobarlLayerOLNumberName++;

    var metadata = {
      Origen: WMSUrl,
      LayerCount: Layers.length,
      Format: Format,
    }

    //constructor(ZDepth, Visible, Nombre, Formato, OpenLayerSource, Listado, Opacacity, CapaPreCargada, Metadata, EstadoDeLaCapa)
    w.map.addLayer(NuevaCapaWMS);

    var layerToAdd = new LayerData({
      //datos de la layer a agregar
        //zDepth:  map.getLayers().getArray().length-1,
        Visible: true,
        Nombre: NombreDeLaCapa,
        Description: descriptionString,
        Formato: "WMS",
        OpenLayerSource: w.map.getLayers().getArray()[ w.map.getLayers().getArray().length-1],
        Listado: false,
        Opacacity: 1,
        CapaPreCargada: false,
        Metadata: metadata,
        EstadoDeLaCapa: "",
        CapaDescargable: true,
        Attributions: "",
        LayerTitles: LayerTitles,
        LayerNames: LayerNames,
      });

      layerToAdd.OpenLayerSource.OriginalName = NombreDeLaCapa;

    w.layersDelMapa.AddLayerToMap( layerToAdd );

    w.layersDelMapaGUI.CreateHTMLElementForLayerData(layerToAdd)

    w.layersDelMapa.ActualizarZIndex()

    w.layersDelMapaGUI.UpdateAllLayersOnGUI();
  }

  //agrega la capa al mapa como wms con los datos pasaos por
  //parametros, esto es para las capas por defecto edsde Config.xml
  w.layersDelMapa.AddLayerFromWMSDefault = function(isActiveByDefault, customeName, description, format, url, layerNames, layerTitles, attributions, imagFormat, transparent, tiled, extent){

    //var Extencion = [0,0,0,0];

    var LayerNames = [];
    var LayerTitles = [];
    var LayerBBox = [];

    let descriptionString =
    `
      <div>
        <span class="W_Layer_NOT_Loaded">Capa cargada por defecto en el visualizador SIGAUy.</span>
        <br />
        <span>${description}</span>
      </div>
    `
    var NombreDeLaCapa = "";

    var NuevaCapaWMS = undefined;

    if(tiled){
      NuevaCapaWMS = new TileLayer({
        className: w.GlobarlLayerOLNumberName,
        // preload: Infinity,
        zIndex: w.map.getLayers().getArray().length *-1,
        // function boundingExtent(coordinates: format.Coordinate[]): olExtent.Extent
        //extent: transformExtent(boundingBoxToUse.GetExtencion(), boundingBoxToUse.GetCRS(), GlobalMapView.getProjection()),
        source: new TileWMS({
          cacheSize: 1024,
          url: url,
          params:{
            Visible:isActiveByDefault,
            LAYERS:layerNames,
            FORMAT:imagFormat,
            TRANSPARENT: transparent
          },
          crossOrigin: 'anonymous',
          attributions: attributions,
        })
      });
    }else{
      NuevaCapaWMS = new ImageLayer({
        className: w.GlobarlLayerOLNumberName,
        // preload: Infinity,
        zIndex: w.map.getLayers().getArray().length *-1,
        // function boundingExtent(coordinates: format.Coordinate[]): olExtent.Extent
        //extent: transformExtent(boundingBoxToUse.GetExtencion(), boundingBoxToUse.GetCRS(), GlobalMapView.getProjection()),
        source: new ImageWMS({
          cacheSize: 1024,
          url: url,
          params:{
            Visible:isActiveByDefault,
            LAYERS:layerNames,
            FORMAT:imagFormat,
            TRANSPARENT: transparent
          },
          crossOrigin: 'anonymous',
          attributions: attributions,
        })
      });
    }



    //attributions

    //subimos el contador de nombre
    w.GlobarlLayerOLNumberName++;

    if(customeName != ""){
      NombreDeLaCapa = customeName;
    }

    var metadata = {
      Origen: url,
      LayerCount: layerNames.length,
      Format: imagFormat,
    }

    w.map.addLayer(NuevaCapaWMS);

    var layerToAdd = new LayerData({
      //datos de la layer a agregar
        //zDepth:  w.map.getLayers().getArray().length-1,
        Visible: isActiveByDefault,
        Nombre: NombreDeLaCapa,
        Description: descriptionString,
        Formato: "WMS",
        OpenLayerSource: w.map.getLayers().getArray()[ w.map.getLayers().getArray().length-1],
        Listado: false,
        Opacacity: 1,
        CapaPreCargada: true,
        Metadata: metadata,
        EstadoDeLaCapa: "",
        CapaDescargable: false,
        Attributions: attributions,
        LayerTitles: layerTitles,
        LayerNames: layerNames,
        BoundingBox: extent,
      });

      layerToAdd.OpenLayerSource.OriginalName = NombreDeLaCapa;
    w.layersDelMapa.AddLayerToMap( layerToAdd );

    window.layersDelMapaGUI.CreateHTMLElementForLayerData(layerToAdd)

    w.layersDelMapa.ActualizarZIndex()

    w.layersDelMapaGUI.UpdateAllLayersOnGUI();
  }

    //agrega la capa al mapa como wms con los datos pasaos por
  //parametros, esto es para las capas por defecto edsde Config.xml
  w.layersDelMapa.AddLayerFromGeoJSONDefault = function(isActiveByDefault, customeName, format, url, layerNames, layerTitles, attributions, estilo){

    var NombreDeLaCapa = "";

    var vectorSource = new VectorSource({ format: new GeoJSON() });

    var estiloProcesado = []

    for(var indice = 0; indice < Math.max(estilo.fillList.length, estilo.strokeList.length); indice++){
      var fill = {
        tipo: "fill",
        color: "rgba(0,0,0,0)",
        zindex: 0,
      }
      var stroke = {
        tipo: "stroke",
        color: "rgba(0,0,0,0)",
        lineDash: "",
        lineCap: "round",
        width: 0,
        zindex: 0,
      }

      if(estilo.fillList.length > indice){
        fill = estilo.fillList[indice];
      }

      if(estilo.strokeList.length > indice){
        stroke = estilo.strokeList[indice];
      }

      estiloProcesado.push(
        new Style({
          fill: new Fill(fill),
          stroke: new Stroke(stroke),
        })
      );
    }

    var NuevaCapaGeoJSON = new VectorLayer({
      style:estiloProcesado,
      className: w.GlobarlLayerOLNumberName,
      // preload: Infinity,
      zIndex: w.map.getLayers().getArray().length *-1,
      // function boundingExtent(coordinates: format.Coordinate[]): olExtent.Extent
      //extent: transformExtent(boundingBoxToUse.GetExtencion(), boundingBoxToUse.GetCRS(), GlobalMapView.getProjection()),
      source: new VectorSource({
        format: new GeoJSON(),
        //url: "http://localhost:53860/VectorLayers/MapaDeBase_Agua.geojson",
        url: url,
        params:{
          Visible:isActiveByDefault,
          LAYERS:layerNames,
        },
        crossOrigin: 'anonymous',
        attributions: attributions,
      })
    });

    //attributions

    //subimos el contador de nombre
    w.GlobarlLayerOLNumberName++;

    if(customeName != ""){
      NombreDeLaCapa = customeName;
    }

    var metadata = {
      Origen: "Archivo GEOJSON remoto",
    }

    let descriptionString =
    `
      <div>
        <span class="W_Layer_NOT_Loaded"> - Capa editable</span>
        <br />
        <span>Capa de geometría subida por el usuario desde archivo.</span>
      </div>
    `

    //constructor(ZDepth, Visible, Nombre, Formato, OpenLayerSource, Listado, Opacacity, CapaPreCargada, Metadata, EstadoDeLaCapa)
    w.map.addLayer(NuevaCapaGeoJSON);

    var layerToAdd = new LayerData({
      //datos de la layer a agregar
        //zDepth:  w.map.getLayers().getArray().length-1,
        Visible: isActiveByDefault,
        Nombre: NombreDeLaCapa,
        Description: descriptionString,
        Formato: "GeoJSON",
        OpenLayerSource: w.map.getLayers().getArray()[ w.map.getLayers().getArray().length-1],
        Listado: false,
        Opacacity: 1,
        CapaPreCargada: true,
        Metadata: metadata,
        EstadoDeLaCapa: "",
        CapaDescargable: false,
        Attributions: attributions,
        LayerTitles: layerTitles,
        LayerNames: layerNames,
      });

      layerToAdd.OpenLayerSource.OriginalName = NombreDeLaCapa;

    w.layersDelMapa.AddLayerToMap( layerToAdd );

      //w.layersDelMapa.Lista.push( layerToAdd );
      //w.layersDelMapa.Lista.splice(0,0,layerToAdd)
      // console.log(layerToAdd)

    window.layersDelMapaGUI.CreateHTMLElementForLayerData(layerToAdd)

    w.layersDelMapa.ActualizarZIndex()
    //w.layersDelMapa.AddLayerToMap( new LayerData( w.map.getLayers().getArray().length-1 , isActiveByDefault, NombreDeLaCapa , "WMS", w.map.getLayers().getArray()[ w.map.getLayers().getArray().length-1], false, 1, true, metadata, ""));
    w.layersDelMapaGUI.UpdateAllLayersOnGUI();
    //console.log(map.getLayers().getArray()[ w.map.getLayers().getArray().length-1]);
  }
//#endregion

//#region FUNCIONES GLOBALES WINDOW

  w.DestroyThisObject = function(obj) {
    for(var prop in obj){
        var property = obj[prop];
        if(property != null && typeof(property) == 'object') {
            destroy(property);
        }
        else {
            obj[prop] = null;
        }
    }
  }

  //funcion que devuelve la capa con el estado proporsionado
  w.GetLayerWithOpenLayerSource = function (OpenLayerSourceToSearch){
    // console.log(w.layersDelMapa.Lista);
    for(var ix = 0; ix < w.layersDelMapa.Lista.length; ix++){
      // console.log("estado de " + w.layersDelMapa.Lista[ix].Nombre + " = " + w.layersDelMapa.Lista[ix].EstadoDeLaCapa)
      if(w.layersDelMapa.Lista[ix].OpenLayerSource == OpenLayerSourceToSearch){
        //los datos de esa capa en LayerData
        return w.layersDelMapa.Lista[ix];

        //los datos de esa capa en ol
        //return w.map.getLayers().getArray()[ix];
      }
    }
    return false;
  }

  w.GetEditableLayersArray = function(){
    var EditableLayers = []
    for(var LayerActual = 0; LayerActual< w.layersDelMapa.Lista.length; LayerActual++){
      if(w.layersDelMapa.Lista[LayerActual].Formato.toLowerCase() != "wms" && w.layersDelMapa.Lista[LayerActual].Formato.toLowerCase() != "basemap" ){
        if(w.layersDelMapa.Lista[LayerActual].CapaPreCargada != true){
          EditableLayers.push(w.layersDelMapa.Lista[LayerActual])
        }
      }
    }

    return EditableLayers;
  }

  //funcion que devuelve la capa con el estado proporsionado
  w.GetLayerWithState = function (StateToSearch){
    // console.log(w.layersDelMapa.Lista);
    for(var ix = 0; ix < w.layersDelMapa.Lista.length; ix++){
      // console.log("estado de " + w.layersDelMapa.Lista[ix].Nombre + " = " + w.layersDelMapa.Lista[ix].EstadoDeLaCapa)
      if(w.layersDelMapa.Lista[ix].EstadoDeLaCapa == StateToSearch){
        //los datos de esa capa en LayerData
        return w.layersDelMapa.Lista[ix];

        //los datos de esa capa en ol
        //return w.map.getLayers().getArray()[ix];
      }
    }
    return false;
  }

  //funcion que devuelve el estado de una capa
  w.GetLayerState = function (layerData){
    //console.log("GetLayerState")
    return layerData.EstadoDeLaCapa;
  }

  w.GetLayerStateById = function (LayerID){
    return w.layersDelMapa.Lista[LayerID].EstadoDeLaCapa;
  }

  //funcion que setea el estado de una capa
  /**
   * @param {LayerData} layerData
   * @param {string} Estado
   */
  w.SetLayerState = function (layerData, Estado){
    layerData.EstadoDeLaCapa = Estado;
  }

  //funcion que setea el estado de una capa
  w.SetLayerStateById = function (LayerID, Estado){
    w.layersDelMapa.Lista[LayerID].EstadoDeLaCapa = Estado;
  }

  //funcion detecta el error de la capa segun el estado de la layer
  w.GetLayerStateError = function (layerData, ErrorText){

    var nombreCapa = layerData.Nombre;
    var formatoCapa = layerData.Formato;

    switch(w.GetLayerState(layerData)){
      //error si se esta descargando
      case "descargando":
        alert(ErrorText + " [" + nombreCapa + "(" + formatoCapa + ")] \nLa capa se esta tratando de descargar.");
        break;

      //error si se esta descargando
      case "editando":
        alert(ErrorText + " [" + nombreCapa + "(" + formatoCapa + ")] \nLa capa se esta editando.");
        break;
    }

  }

  //funcion detecta el error de la capa segun el estado de la layer pero busca por ID
  w.GetLayerStateErrorById = function (LayerID, ErrorText){

    var nombreCapa = w.layersDelMapa.Lista[LayerID].Nombre;
    var formatoCapa = w.layersDelMapa.Lista[LayerID].Formato;

    switch(w.SetLayerStateById(LayerID)){
      //error si se esta descargando
      case "descargando":
        alert(ErrorText + " [" + nombreCapa + "(" + formatoCapa + ")] \nLa capa se esta tratando de descargar.");
        break;

      //error si se esta descargando
      case "editando":
        alert(ErrorText + " [" + nombreCapa + "(" + formatoCapa + ")] \nLa capa se esta editando.");
        break;
    }

  }

  // hace zoom a la capa de diferentes formas segun el tipo de capa
  w.ZoomToLayerByID = function( LayerToZoomID ){
    var ListaDeLayers = w.map.getLayers().getArray();
    var LayerToZoom = ListaDeLayers[LayerToZoomID];
    //console.log( LayerToZoom.getSource().getExtent() );

    switch (layersDelMapa.Lista[LayerToZoomID].Formato.toLowerCase()) {
      case "wms":
          ZoomNoEmptyExtentWMS(LayerToZoom);
        break;

      case "basemap":

        break;

      default:
          ZoomNoEmptyLayer(LayerToZoom);
      break;
    }

    //w.map.getView().fit( LayerToZoom.getExtent(), w.map.getSize());
  }

  //zoom a la capa, usa los demas zoom segun el formato
  w.ZoomToLayer = function( LayerDataToZoom ){
    var LayerToZoom = LayerDataToZoom;
    //console.log( LayerToZoom.getSource().getExtent() );

    switch (LayerToZoom.Formato.toLowerCase()) {
      case "wms":
          ZoomNoEmptyExtentWMS(LayerToZoom);
        break;

      case "basemap":

        break;

      default:
          ZoomNoEmptyLayer(LayerToZoom.OpenLayerSource);
      break;
    }

    //w.map.getView().fit( LayerToZoom.getExtent(), w.map.getSize());
  }

  //ZOOM EXTENT pero chequea si el extent del WMS existe primero
  w.ZoomNoEmptyExtentWMS = async function(LayerToZoom){
    if(LayerToZoom.GetExtentTransformed() != undefined){
      w.map.getView().fit( LayerToZoom.GetExtentTransformed());
    }else{
      /* si la capa no tiene extent es probable que sea un wms
      de los agregados por defecto. */

      let extentFromWMS = await w.GetExtentFromWMSCapabilities(LayerToZoom.OpenLayerSource)
      LayerToZoom.SetExtent(extentFromWMS)

      if(LayerToZoom.GetExtentTransformed() != undefined)
      {
        w.map.getView().fit( LayerToZoom.GetExtentTransformed());
      }
    }

    // console.log(LayerToZoom)
    // console.log(LayerToZoom.GetExtentTransformed())
    console.log(` > Zoom to Extent (${LayerToZoom.Nombre})[${LayerToZoom.GetExtentTransformed()}]`)
  }

  /**
   *
   * @param {layer} LayerToUse
   */
  w.GetExtentFromWMSCapabilities = async function(LayerToUse){
    let source = LayerToUse.getSource();
    let LayerURL = source.getUrl?.() || source.getUrls?.()[0];

    let XMLResults = await w.ReadXML(LayerURL);

    if(XMLResults)
    {
      //obtengo las layers del xml

      let layersXML = w.XMLGetLayers(XMLResults);

      //obtengo la lista de layers cargadas del wms
      let LayersLoaded = LayerToUse.getSource().getParams().LAYERS;

      let XML_LayersFiltered = w.XMLGetLayersByNames(layersXML, LayersLoaded)

      let List_BaundingBoxes = []
      for(let i = 0; i < XML_LayersFiltered.length; i++){
        List_BaundingBoxes.push(w.XMLGetBoundingBoxSRS(XML_LayersFiltered[i]));
      }

      let Final_BoundingBox = w.XMLGetCombinedBoundingBox(List_BaundingBoxes);

      return Final_BoundingBox;
    }
  }

  //ZOOM GEOMETRY pero chequea si la capa no esta vacia
  w.ZoomNoEmptyLayer = function(LayerToZoom){
    if(LayerToZoom.getSource().getExtent()[0] != Infinity){
      w.map.getView().fit( LayerToZoom.getSource().getExtent());
    }
  }

  //DESCARGAR la capa con el id LaterID
  w.layersDelMapa.DescargarCapa = function(layerData, nombre, formato){
    var Extension = "." + formato.toLowerCase();
    var FileMimeType;

    var filename = nombre + Extension;
    var format;

    let Layer = layerData.OpenLayerSource
    let sourceDeLaLayer =  Layer.getSource();
    const featuresDelLayer = sourceDeLaLayer.getFeatures();

    const projection = sourceDeLaLayer.getProjection?.() || w.map.getView().getProjection();
    let options = { featureProjection: projection };

    //const download = document.getElementById('download');
    switch (formato.toLowerCase()) {
      case "kml":
        const layerStyle = Layer.getStyle();

        format = new KML({
            writeStyles: true  // Esto incluye los estilos en el KML
        });
        // Si el estilo es una función (como suele ser), aplicarlo a cada feature
        if (typeof layerStyle === 'function') {
            featuresDelLayer.forEach(f => {
                f.setStyle(layerStyle(f));
            });
        } else if (layerStyle) {
            // Si es un estilo directo
            featuresDelLayer.forEach(f => {
                f.setStyle(layerStyle);
            });
        }

        FileMimeType = 'data:application/vnd.google-earth.kml+xml;charset=utf-8;';
        break;

      case "geojson":
      case "json":
        format = new GeoJSON();
        FileMimeType = 'data:text/json;charset=utf-8,';
        break;
    }

    const data = format.writeFeatures(featuresDelLayer, options);
    //console.log(data);

    var file = new Blob([data], {type: FileMimeType});

    if (w.navigator.msSaveOrOpenBlob) // IE10+
        w.navigator.msSaveOrOpenBlob(file, filename);
    else { // Others
        var a = document.createElement("a"),
        url = URL.createObjectURL(file);
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        setTimeout(function() {
            document.body.removeChild(a);
            w.URL.revokeObjectURL(url);
        }, 0);
    }
  }

  //sube una capa pasada como Archivo por parametro, tambien
  //la coloca en el mapa y dispara la actualizacion de la hud
  w.layersDelMapa.UploadLayer = function(UloadedFile) {

    //guardo el nimero de la ultima capa existente en el mapa
    var lastLayerNumber = (w.map.getLayers().getArray().length)-1;

    //el archivo a subir
    var file = UloadedFile;

    // creo una url con el archivo
    var fileURL = URL.createObjectURL(file);

    //Guardo el nombre del archivo que se cargo
    var fileName = file.name;

    //tomo el formato del archivo subido
    var fileFormat = fileName.split('.')[1];

    //declaro elvector source que mas abajo se usar
    var vectorSourceFormated =  null;

    //compruebo si hay un archivo
    if (file) {
      //seteamos el formato al VectorSource que tendra la layer resiltado
      switch(fileFormat.toLowerCase()){
        case "kml":
          vectorSourceFormated = new VectorSource({ format: new KML() });
          break;

        case "json":
          vectorSourceFormated = new VectorSource({ format: new GeoJSON() });
        break;

        case "geojson":
          vectorSourceFormated = new VectorSource({ format: new GeoJSON() });
          break;

        case "igc":
          vectorSourceFormated = new VectorSource({ format: new IGC() });
          break;

        case "topojson":
          vectorSourceFormated = new VectorSource({ format: new TopoJSON() });
          break;

        case "tif":
          vectorSourceFormated = new GeoTIFF({
            sources:[
              {
                url: fileURL
              }
            ]
          });

          break;
      }

      //seteo el url de la capa generada
      if(fileFormat.toLowerCase() != "tif"){
        vectorSourceFormated.setUrl(fileURL);

        //creamos la capa con el source
        var vector = new VectorLayer({
          className: w.GlobarlLayerOLNumberName,
          zIndex: (lastLayerNumber + 1)*-1,
          source: vectorSourceFormated
        });
      }else{

        //creamos la capa con el source
        var vector = new TileLayer({
          className: w.GlobarlLayerOLNumberName,
          zIndex: (lastLayerNumber + 1)*-1,
          source: vectorSourceFormated
        });
      }

      console.log(` > UploadLayer (${fileName.split('.')[0]} [${fileFormat}]) -> layer data loaded`)


      //subimos el contador de nombre
      w.GlobarlLayerOLNumberName++;

      //agrego la capa al mapa
      w.map.addLayer(vector);

      //creo los metadatos
      var metadato = {
        Origen:fileName,
      }

      let descriptionString =
      `
        <div>
          <span class="W_Layer_NOT_Loaded"> - Capa editable</span>
          <br />
          <span>Capa de geometría subida por el usuario desde archivo.</span>
        </div>
      `

      //agrego la capa al listado
      var layerToAdd = new LayerData({
        //datos de la layer a agregar
          //zDepth: lastLayerNumber + 1,
          Visible: true,
          Nombre: fileName.split('.')[0],
          Description: descriptionString,
          Formato: fileFormat,
          OpenLayerSource: w.map.getLayers().getArray()[w.map.getLayers().getArray().length-1],
          Listado: false,
          Opacacity: 1,
          CapaPreCargada: false,
          Metadata: metadato,
          EstadoDeLaCapa: "",
          CapaDescargable: true,
          Attributions: "",
        });

        layerToAdd.OpenLayerSource.OriginalName = fileName.split('.')[0];

      w.layersDelMapa.AddLayerToMap( layerToAdd );

      //w.layersDelMapa.Lista.push( layerToAdd );
      //w.layersDelMapa.Lista.splice(0,0,layerToAdd)

      w.layersDelMapaGUI.CreateHTMLElementForLayerData(layerToAdd)

      w.layersDelMapa.ActualizarZIndex()
      //w.layersDelMapa.AddLayerToMap( new LayerData(lastLayerNumber + 1,true, fileName.split('.')[0], fileName.split('.')[1].toUpperCase(), w.map.getLayers().getArray()[lastLayerNumber + 1], false, 1, false, metadato, ""));

      //actualizo la GUI
      w.layersDelMapaGUI.UpdateAllLayersOnGUI();

      //trato de hacerle zoom a la capa nueva
      if(fileFormat.toLowerCase() != "tif"){
        Test_ZoomToLastLayer( w.map.getLayers().getArray()[ w.map.getLayers().getArray().length-1 ], 0, 5);
      }
    }
    console.log(` > UploadLayer (${fileName.split('.')[0]} [${fileFormat}]) -> layer data loaded to Map and LayerList`)
  };

  //BORRA la capa que se pasa por parmetro pero por ID (LayersDelMapa.Lista[LayerID]))
  w.layersDelMapa.DeleteLayerByID = function(LayerID){
    w.map.removeLayer(w.map.getLayers().getArray()[LayerID])
    layersDelMapa.Lista.splice(LayerID, 1);
  }

  //cancela el eliminado de layer by LayerData
  w.layersDelMapa.CancelDeleteLayerByLayerData = function(layerData){
    w.SetLayerState(layerData, "");
    w.Update_EditableLayersTable();
  }

  //BORRA la capa que se pasa por parmetro (LayerData)
  w.layersDelMapa.DeleteLayerByLayerData = function(layerData){
    var indiceAEliminar = w.layersDelMapa.Lista.indexOf(layerData)
    var indiceAEliminarOL = w.map.getLayers().getArray().indexOf(layerData.OpenLayerSource)

    w.map.removeLayer(w.map.getLayers().getArray()[indiceAEliminarOL])
    layersDelMapa.Lista.splice(indiceAEliminar, 1);

    w.layersDelMapa.ActualizarZIndex()

    w.layersDelMapaGUI.UpdateAllLayersOnGUI();

    w.Update_EditableLayersTable();

  }

  //cambia la opacacidad de la capa co la id Layer ID y el valor Value
  w.layersDelMapa.SetOpacacityByID = function(LayerID, value){
    w.map.getLayers().getArray()[LayerID].set("opacity", value);
  }

  w.layersDelMapa.SetOpacacity = function(layerData, value){
    layerData.OpenLayerSource.set("opacity", value);
  }

  //Obtiene el valor de opacacidad de la capa de id LayerID
  w.layersDelMapa.GetOpacacityByID = function(LayerID){
    return w.map.getLayers().getArray()[LayerID].get("opacity");
  }

  w.layersDelMapa.GetOpacacity = function(layerData){
    return layerData.OpenLayerSource.get("opacity");
  }

//#endregion

//#region VARIABLES GLOBALES

  //declaro la lista inicial
  w.layersDelMapa.Lista = [];

  //declaro el estado inicial de la variable EditionEnabled
  w.EditionEnabled = false;

//#endregion

//#region Zona de XML para WMS

  w.LastXML = null;
  w.OptionsXML = null;

  //#region OPTIONS XML (opciones por defecto)


    //lee las opciones de la view del XML
    var ReadDefaultView = function(){
      //variable para alojar los datos de la default view en HTML
      var ViweOptions = ConfigurationJSON.DefaultView;
      w.GlobalDefaultMapView = new w.CustomeView(
          /*projection:*/ ViweOptions.Projection,
          /*center:*/    [ViweOptions.CenterX, ViweOptions.CenterY],
          /*zoom:*/       ViweOptions.Zoom,
          /*minZoom:*/    ViweOptions.MinZoom,
          /*maxZoom:*/    ViweOptions.MaxZoom
        );

        //seto la projeccion
        w.GlobalMapView = new View({
          projection: w.GlobalDefaultMapView.projection,
              center: w.GlobalDefaultMapView.center,
                zoom: w.GlobalDefaultMapView.zoom,
             minZoom: w.GlobalDefaultMapView.minZoom,
             maxZoom: w.GlobalDefaultMapView.maxZoom,
        });

        //w.GlobalMapView.setZoom(w.GlobalDefaultMapView.zoom);
    }

    //funcion para subir wms (usada para las capas por defecto)
    var DefaultWMSLoad = function(isActiveByDefault, customeName, description, format, url, layerNames,
                                  layerTitles, attributions, imagFormat, transparent, tiled, extent){
      w.layersDelMapa.AddLayerFromWMSDefault(
        isActiveByDefault,
        customeName,
        description,
        format,
        url,
        layerNames,
        layerTitles,
        attributions,
        imagFormat,
        transparent,
        tiled,
        extent)
    }

    //funcion para subir wms (usada para las capas por defecto)
    var DefaultGeoJSONLoad = function(isActiveByDefault, customeName, format, url, layerNames,
                                      layerTitles, attributions, estilo){
      w.layersDelMapa.AddLayerFromGeoJSONDefault(
        isActiveByDefault,
        customeName,
        format,
        url,
        layerNames,
        layerTitles,
        attributions,
        estilo)
    }

    //lee las layers del xml de opciones
    var ReadDefaultLayers = function(){
      console.warn(" > Cargando Capas por defecto...");

      var LayersToLoad = ConfigurationJSON.DefaultData;

      console.warn("   > Capas Por defecto a cargar: " + LayersToLoad.length);

      //reviso cada capa 1 por una
      for(var CapaActual = 0; CapaActual < LayersToLoad.length; CapaActual++){
        // console.log(LayersToLoad[CapaActual]);
        var formatosImplementados = "(wms, geojson)"

        // console.log(LayersToLoad[CapaActual])

        //si la capa comenza ensendida
        var isActiveByDefault = (LayersToLoad[CapaActual].Activated);

        //el nombre de la capa
        var customeName = LayersToLoad[CapaActual].CustomName;

        //la descripcion de la capa
        var description = LayersToLoad[CapaActual].Description;

        //el formato de la capa
        var format = LayersToLoad[CapaActual].Format;

        //detcto si se paso un valor incorrecto
        if( typeof isActiveByDefault != "boolean"){
          console.error("el valor de ''Activated'' de la capa: " + CapaActual + " (customeName: " + customeName + " ) es incorrecto, \nse esparaba true o false, pero se obtubo:''" + isActiveByDefault + "''")
        }

        //
        var parameters = LayersToLoad[CapaActual].Parameters;


        //url de la capa
        var url = parameters.URL;

        //nombres de la capa
        var layerNames = parameters.LayerNames;
        var layerTitles = parameters.LayerTitles;

        //le quito los espacios sobrantes
        for(var lindex = 0; lindex<layerNames.length; lindex++){
          layerNames[lindex] = layerNames[lindex].trim();
        }
        for(var lindex = 0; lindex<layerTitles.length; lindex++){
          layerTitles[lindex] = layerTitles[lindex].trim();
        }

        //el copyright de cada capa
        var attributions = parameters.Attributions;
        var attributions_txt = parameters.Attributions_TXT;
        var attributions_url = parameters.Attributions_URL;

        switch(format.toLowerCase()){
          case "wms":

            //los parametros espesificos del WMS
            var parameters = LayersToLoad[CapaActual].Parameters;
            var imagFormat = parameters.ImagFormat;
            var transparent = parameters.Transparent;
            var tiled = parameters.Tiled;
            var extent = undefined

            if(parameters.Extent){
              extent = new BoundingBox(
                parameters.Extent.CRS,
                parameters.Extent.XMin,
                parameters.Extent.YMin,
                parameters.Extent.XMax,
                parameters.Extent.YMax
              );
            }


            //agrego la capa al mapa
            DefaultWMSLoad(isActiveByDefault, customeName, description, format, url, layerNames, layerTitles, [attributions_url, attributions_txt], imagFormat, transparent, tiled, extent);

            break;

          case "geojson":

            //los parametros espesificos del GeoJSON
            var parameters = LayersToLoad[CapaActual].Parameters;
            var symbol = parameters.Symbol;
            var fillList = symbol.filter(simbolo => simbolo.Type.toLowerCase() == "fill");
            var strokeList = symbol.filter(simbolo => simbolo.Type.toLowerCase() == "stroke");

            //creo el objeto con el estilo
            var estilo = {
              fillList:[],
              strokeList:[],
            }

            //reviso los fill
            for(var actualFill = 0; actualFill < fillList.length; actualFill++){
              var fill = fillList[actualFill];
              estilo.fillList.push(
                {
                  color: (fill.Color == undefined? 'rgba(0,0,0,1)': fill.Color),
                  zindex: (fill.ZIndex == undefined? actualFill: fill.ZIndex),
                }
              )
            }

            //reviso los stroke
            for(var actualStroke = 0; actualStroke < strokeList.length; actualStroke++){
              var stroke = strokeList[actualStroke];
              estilo.strokeList.push(
                {
                  color: (stroke.Color == undefined? 'rgba(0,0,0,1)': stroke.Color),
                  width: (stroke.width == undefined? 0: stroke.width),
                  zindex: (stroke.ZIndex == undefined? actualStroke: stroke.ZIndex),
                  lineDash: (stroke.lineDash == undefined? '': stroke.lineDash.split(',')),
                  lineCap: (stroke.lineCap == undefined? 'round': (stroke.lineCap.toLowerCase() != 'butt' && stroke.lineCap.toLowerCase() != 'square')? 'round': stroke.lineCap.toLowerCase()),
                  lineJoin: (stroke.lineJoin == undefined? 'round': (stroke.lineJoin.toLowerCase() != 'bevel' && stroke.lineJoin.toLowerCase() != 'miter')? 'round': stroke.lineJoin.toLowerCase()),
                }
              )
            }

            //agrego la capa al mapa
            DefaultGeoJSONLoad(isActiveByDefault, customeName, format, url, layerNames, layerTitles, [attributions_url, attributions_txt], estilo);

            break;

          default:
            //reporto el error de que se paso incorrecto el formato o no es soportado
            console.error(`el valor de ''Formato'' de la capa: ${CapaActual} (customeName: + ${customeName} ) es incorrecto o es un formato no implementado, formatos implementados: ${formatosImplementados}`)
            break;
        }

      }//end for

      console.warn("   > capas cargadas Listo");

    }//w.ReadDefaultLayers


    w.JSON_OptionsRead = function(){
      console.warn("Leyendo Opciones de Config.json ...");
      // console.warn(ConfigurationJSON);

      //cargo los datos de la proyeccion por defecto, vienen de config.json
      ReadDefaultView();

      console.warn(" > Default Projection: " + w.GlobalMapView.getProjection().getCode() );

      //instancio el mapa
      InstanciarMapa();

      setTimeout( ()=>{
        ReadDefaultLayers();

        if(ConfigurationJSON.DefaultView.Scale != undefined){
          w.setProjectionOnMap( w.GlobalDefaultMapView.projection)

          w.SetScaleOnMap(ConfigurationJSON.DefaultView.Scale);

          setTimeout( ()=>{
            //esto es para tomar el tamaño luego de que se tiene pronto el zoom
            w.GlobalDefaultMapView.zoom = w.GlobalMapView.getZoom();
            // console.log("despues de 1 seg ")
            // console.log(w.GlobalDefaultMapView.zoom)
            // console.log(w.GlobalMapView.getZoom())
          }, 1000);
        }
      }, 200);

      if(w.isMobile == true){
        //cambia la barra de escala para que no sea gigante
        w.scaleBarAndroidVersion();
      }

      console.warn("> Visualizador Listo");
    }

    //hay que hacer que esto funciones. ahora mismo
    //solo funciona usando el Objeto Requiered
    //w.XMLOptionsRead("./Config.xml");
    //objeto con el xml llamado para ser cargado
    //w.XMLOptionsRead(Configuration);


  //#endregion

  //#region XML WMS

    w.currentAbortController = null;
    w.processID = 0

    /**- retorna el XML resultante del GetCapabilities del link del WMS pasado por parametro
    * @param {string} LinkWMS - Link del wms
    * @returns {Promise<string>} XML como texto (o undefined si fue abortada)
    */
    w.ReadXML = async function(linkWMS){

      const localProcessID = ++w.processID;
      // console.log(`${localProcessID} ➜ START ReadXML(${linkWMS})`);

      // Armar la URL final
      const capParams = 'SERVICE=WMS&VERSION=1.3.0&REQUEST=GetCapabilities';
      const finalURL =
        linkWMS.includes('GetCapabilities') ? linkWMS :
        linkWMS.endsWith('?')               ? linkWMS + capParams
                                            : linkWMS + '?' + capParams;

      // Si hay una petición anterior pendiente, la abortamos
      if (w.currentAbortController) {
        w.currentAbortController.abort();        // cancela el fetch previo
      }

      // reamos un controller nuevo para ESTA petición
      const controller = new AbortController();
      w.currentAbortController = controller;     // lo guardamos globalment

      // console.log(`${localProcessID} - Se esta realizando la consulta GetCapabilities`);

      try {
        const response = await fetch(finalURL,{
          signal: controller.signal,
          headers: {'Accept': 'application/xml'}
        });
        const xmlText  = await response.text();

        /* 4️⃣ parsear a DOM */
        const xmlDoc = new DOMParser().parseFromString(xmlText, 'application/xml');
        // console.log(`${localProcessID} ✔ XML listo`);
        return xmlDoc;

      } catch (err) {
        if (err.name === 'AbortError') {
           console.warn(`${localProcessID} ⚠ abortado por nueva petición`);
          return;
        }
        console.error(`${localProcessID} ✖ error al tratar de obtener WMS GetFeature info`, err);
        throw err; // otro tipo de error
      } finally {
        // limpia el controller si este era el activo
        if (w.currentAbortController === controller)
          w.currentAbortController = null;
      }
    }


    //xml con los datos del WMS
    //lee el xml de un wms remoto y lo devuelve en formato xml
    w.XMLRead = function(LinkWMS, HTMLToModify){

      //Get Capability Request
      var getCapabilities_V130 = "SERVICE=WMS&VERSION=1.3.0&REQUEST=GetCapabilities";

      //chequeamos si es posible hacer la consulta (dependera del browser)
      if (w.XMLHttpRequest)
      {
      // Objeto para IE7+, Firefox, Chrome, Opera, Safari
      var xmlhttp=new XMLHttpRequest();
      }else{
      // Objeto para IE6, IE5
      var xmlhttp=new ActiveXObject("Microsoft.XMLHTTP");
      }

      var finalLink = "";

      // Abrimos el archivo que esta alojado en el servidor cd_catalog.xml
      if(LinkWMS.indexOf("GetCapabilities") != -1){
        finalLink = LinkWMS;
      }else{
        if(LinkWMS[LinkWMS.length-1] == '?'){
          finalLink =  LinkWMS + getCapabilities_V130;
        }else{
          finalLink =  LinkWMS + "?" + getCapabilities_V130;
        }
      }

    //check the state of XML request
    xmlhttp.onreadystatechange=function() {
        if (xmlhttp.readyState === 4){   //if complete
            if(xmlhttp.status === 200){  //check if "OK" (200)
                //success
                //console.log("Exito " + xmlhttp.status);
                if(xmlhttp.responseXML != w.LastXML){
                  w.LastXML = xmlhttp.responseXML;

                  if(HTMLToModify!=null){
                    w.CrearListaDeDatosXML(w.LastXML, HTMLToModify);
                  }
                }
            } else {
                //fail
                // console.log("Falló");
                //console.log("Falló " + xmlhttp.status);
                w.LastXML = null;
                if(HTMLToModify!=null){
                  //this tecnicaly seys Error + Error number
                  w.MostrarErrorListaDeDatosXML(w.LastXML, HTMLToModify, xmlhttp.status);
                }
            }
        }
    }

    xmlhttp.open("GET", finalLink , true);

    try
    {
      xmlhttp.send("HEAD");
    }
    catch(e)
    {
      //this is caching an error, but ever seys Error 0 (Host not resolved)
      //and its a lie, if i write an incorrect link but resolvible seys error 0 too
      //console.log("Error");

      w.LastXML = null;

      if(HTMLToModify!=null){
        w.MostrarErrorListaDeDatosXML(w.LastXML, HTMLToModify, xmlhttp.status);
      }
    }
  }

  //lista de layers con titulo, nombre y bbox
  //toma un xml y te devuevle las layers
  /**
   *
   * @param {[HTMLelement]} layersXML
   * @param {[string]} layerList
   * @returns
   */
  w.XMLGetLayersByNames = function (layersXML, layerList){
    let LayerFiltered = []

    for(let i = 0; i < layersXML.length; i++){
      let layerFund = null;

      let LayerNameValue = w.XMLGetLayerName(layersXML[i]);
      // /** DEBUG */ console.log(`- LAYER ${i} ---------------------`);
      // /** DEBUG */ console.log(`   ${LayerNameValue}`);


      for(let j = 0; j < layerList.length; j++){
        if(LayerNameValue == layerList[j]){
          // /** DEBUG */ console.log(`   >Fund in j = ${j}`);
          layerFund = layersXML[i];
          break;
        }
      }

      if(layerFund !=null){
        LayerFiltered.push(layerFund);
      }

    }
    return LayerFiltered;
  }

  //lista de layers con titulo, nombre y bbox
  //toma un xml y te devuevle las layers
  w.XMLGetLayers = function (xmlDoc) {
    const allLayers = xmlDoc.getElementsByTagName("Layer");
    const result = [];

    for (let i = 0; i < allLayers.length; i++) {
      const layer = allLayers[i];

      // ¿Tiene hijos <Layer>? Entonces es un nodo contenedor, no un layer real
      const childLayers = layer.getElementsByTagName("Layer");

      if (childLayers.length === 0) {
        result.push(layer);
      }
    }

    return result;
  };

  //nombre de la capa para el usuario
  //toma una layer en xml y te devuelve el titulo
  w.XMLGetLayerTitle = function (Layer){
    var LayerTitle_XML = Layer.getElementsByTagName("Title")[0].childNodes[0].nodeValue;
    return LayerTitle_XML;
  }

  //nombre de la capa necesaria para cargarla en OL
  //toma una layer en xml y te devuelve el nombre
  w.XMLGetLayerName = function (Layer){
    var LayerName_XML=Layer.getElementsByTagName("Name")[0].childNodes[0].nodeValue;
    return LayerName_XML;
  }

  //descripcion de la capa necesaria para cargarla en OL
  //toma una layer en xml y te devuelve la descripcion
  w.XMLGetLayerDescription = function (Layer){
        var LayerName_XML=Layer.getElementsByTagName("Abstract")[0].childNodes[0].nodeValue;
    return LayerName_XML;
  }

  //toma una layer en xml y te devuelve el bbox,
  //necesario para hacerle zoom, es el area de influencia
  w.XMLGetBoundingBox = function (layer){

    var boundingBox = [];

    //wsen
    var westBoundLongitude= layer.getElementsByTagName("westBoundLongitude")[0].childNodes[0].nodeValue;
    var southBoundLatitude= layer.getElementsByTagName("southBoundLatitude")[0].childNodes[0].nodeValue;
    var eastBoundLongitude= layer.getElementsByTagName("eastBoundLongitude")[0].childNodes[0].nodeValue;
    var northBoundLatitude= layer.getElementsByTagName("northBoundLatitude")[0].childNodes[0].nodeValue;

    var Xmin = westBoundLongitude;
    var Ymin = southBoundLatitude;
    var Xmax = eastBoundLongitude;
    var Ymax = northBoundLatitude;

    // BoundingBox.push(westBoundLongitude);
    // BoundingBox.push(southBoundLatitude);
    // BoundingBox.push(eastBoundLongitude);
    // BoundingBox.push(northBoundLatitude);

    boundingBox.push(Xmin, Ymin, Xmax, Ymax);

    return boundingBox;
  }

  //toma una layer en xml y te devuelve el bbox,
  //necesario para hacerle zoom, es el area de influencia
  w.XMLGetBoundingBoxSRS = function (layer){

    var boundingBox = null;

    //guardo el elemento sacado del XML
    var boundingBoxXML = layer.getElementsByTagName("BoundingBox")[0];

    //revisando los atributos del elemento XML
    //seteo los parametros en el objero Bounding Box
    boundingBox = new BoundingBox();

    boundingBox.CRS = boundingBoxXML.getAttribute('CRS');
    boundingBox.XMin = parseFloat(boundingBoxXML.getAttribute('minx'));
    boundingBox.YMin = parseFloat(boundingBoxXML.getAttribute('miny'));
    boundingBox.XMax = parseFloat(boundingBoxXML.getAttribute('maxx'));
    boundingBox.YMax = parseFloat(boundingBoxXML.getAttribute('maxy'));

    //console.log("resultado = " + BoundingBox.ToString());

    return boundingBox;
  }

  //combina Boundingboxes oara crear una mas grande que las contenga a todas
  w.XMLGetCombinedBoundingBox = function (boundingBoxes){

    // console.log("ejecutando XMLGetCombinedBoundingBox");

    let finalExtension = boundingBoxes[0].GetExtencion();

    //reviso la lista de bounding boxes
    for(var BoxIndex = 1; BoxIndex<boundingBoxes.length; BoxIndex++){

      finalExtension = extend(finalExtension, boundingBoxes[BoxIndex].GetExtencion());

    }
    // console.log("final extension")
    // console.log(finalExtension)

    //creo los extremos opuestos para usarlos mas tarde
    var Xmin = finalExtension[0];
    var YMin = finalExtension[1];
    var XMax = finalExtension[2];
    var YMax = finalExtension[3];


    var boundingBox = new BoundingBox(boundingBoxes[0].GetCRS(),  Xmin, YMin, XMax, YMax);

    // console.log("return " + BoundingBox.ToString());

    return boundingBox;
  }


//#endregion

//#endregion

//#region INTERACCIONES PARA EDITAR
//array con las inteacciones
w.interacciones= [];

w.ResetInteractions = function (){
  for(var iterX = 0; iterX < w.interacciones.length; iterX++){
    w.map.removeInteraction(w.interacciones[iterX]);
  }
  w.interacciones= [];

  w.ResetLayerDeMedir()
}

w.AddInteractionOnMap = function(interaccion){
  w.interacciones.push(interaccion)
  w.map.addInteraction(interaccion);
}

w.CreateDraw = function(layer, type){
  var layerSource = layer.getSource();

  var draw = new Draw({
    source: layerSource, /* w.GetLayerWithState("editando") */
    type: type, /*Point'*/
    })

  return draw;
}

/**
 * Currently drawn feature.
 * @type {import("ol/Feature").FeatureClass}
 */
 var sketch;

 /**
  * The help tooltip element.
  * @type {HTMLElement}
  */
 var helpTooltipElement;

 /**
  * Overlay to show the help messages.
  * @type {Overlay}
  */
 var helpTooltip;

 /**
  * The measure tooltip element.
  * @type {HTMLElement}
  */
 var measureTooltipElement;

 /**
  * Overlay to show the measurement.
  * @type {Overlay}
  */
 var measureTooltip;

 /**
  * Message to show when the user is drawing a polygon.
  * @type {string}
  */
 var continuePolygonMsg = 'Click para continuar midiendo área';

 /**
  * Message to show when the user is drawing a line.
  * @type {string}
  */
 var continueLineMsg = 'Click para continuar midiendo distáncia';

/**
 * Format length output.
 * @param {LineString} line The line.
 * @return {string} The formatted length.
 */
 var formatLength = function (line) {
  var length = getLength(line);
  var output;
  if (length > 100) {
    output = Math.round((length / 1000) * 100) / 100 + ' ' + 'km';
  } else {
    output = Math.round(length * 100) / 100 + ' ' + 'm';
  }
  return output;
};

/**
 * Format area output.
 * @param {Polygon} polygon The polygon.
 * @return {string} Formatted area.
 */
var formatArea = function (polygon) {
  var area = getArea(polygon);
  var output;
  if (area > 10000) {
    output = Math.round((area / 1000000) * 100) / 100 + ' ' + 'km<sup>2</sup>';
  } else {
    output = Math.round(area * 100) / 100 + ' ' + 'm<sup>2</sup>';
  }
  return output;
};

/**
 * Creates a new measure tooltip
 */
 function createMeasureTooltip() {
  if (measureTooltipElement) {
    measureTooltipElement.parentNode.removeChild(measureTooltipElement);
  }
  measureTooltipElement = document.createElement('div');
  measureTooltipElement.className = 'ol-tooltip ol-tooltip-measure';
  measureTooltip = new Overlay({
    element: measureTooltipElement,
    offset: [0, -15],
    positioning: 'bottom-center',
  });
  w.map.addOverlay(measureTooltip);
}

/**
 * Creates a new help tooltip
 */
 function createHelpTooltip() {
  if (helpTooltipElement) {
    helpTooltipElement.parentNode.removeChild(helpTooltipElement);
  }
  helpTooltipElement = document.createElement('div');
  helpTooltipElement.className = 'ol-tooltip hidden';
  helpTooltip = new Overlay({
    element: helpTooltipElement,
    offset: [15, 0],
    positioning: 'center-left',
  });
  w.map.addOverlay(helpTooltip);
}

w.ResetLayerDeMedir = function(){
  w.LayerParaMedir.setSource(new VectorSource({}))

  var listaDeOverlays = w.map.getOverlays().getArray()

  if(listaDeOverlays.length > 0){
    for(var overlayActual = listaDeOverlays.length; overlayActual > -1; overlayActual--){
      w.map.removeOverlay(w.map.getOverlays().getArray()[overlayActual])
    }
  }
}

//estilo por defecto hardcodeado para las capas nuevas
w.defaultSymbol =  new Style({
  fill: new Fill({
    color: 'rgba(237, 59, 59, 0.4)',
  }),
  stroke: new Stroke({
    width: 2,
    color: 'rgba(250, 10, 10, 0.8)',
  }),
  image: new CircleStyle({
    radius: 5,
    stroke: new Stroke({
      width: 2,
      color: 'rgba(250, 10, 10, 0.8)',
    }),
    fill: new Fill({
      color: 'rgba(237, 59, 59, 0.4)',
    }),
  }),
});



//SIMBOLO MEDIR
w.CreateMedir = function(type){

  var Medir = new Draw({
    source: w.LayerParaMedir.getSource(), /*la capa que se usa para medir*/
    type: type,
    style: new Style({
      fill: new Fill({
        color: 'rgba(255, 255, 255, 0.2)',
      }),
      stroke: new Stroke({
        color: 'rgba(0, 0, 0, 0.5)',
        lineDash: [10, 10],
        width: 2,
      }),
      image: new CircleStyle({
        radius: 5,
        stroke: new Stroke({
          color: 'rgba(0, 0, 0, 0.7)',
        }),
        fill: new Fill({
          color: 'rgba(255, 255, 255, 0.2)',
        }),
      }),
    }),
  });
  w.AddInteractionOnMap(Medir)

  createMeasureTooltip();
  createHelpTooltip();

  var listener;
  Medir.on('drawstart', function (evt) {
    // set sketch
    sketch = evt.feature;

    /** @type {import("../src/ol/coordinate.js").Coordinate|undefined} */
    var tooltipCoord = evt.coordinate;

    listener = sketch.getGeometry().on('change', function (evt) {
      var geom = evt.target;
      var output;
      if (geom instanceof Polygon) {
        output = formatArea(geom);
        tooltipCoord = geom.getInteriorPoint().getCoordinates();
      } else if (geom instanceof LineString) {
        output = formatLength(geom);
        tooltipCoord = geom.getLastCoordinate();
      }
      measureTooltipElement.innerHTML = output;
      measureTooltip.setPosition(tooltipCoord);
    });
  });

  Medir.on('drawend', function () {
    measureTooltipElement.className = 'ol-tooltip ol-tooltip-static';
    measureTooltip.setOffset([0, -7]);
    // unset sketch
    sketch = null;
    // unset tooltip so that a new one can be created
    measureTooltipElement = null;
    createMeasureTooltip();
    unByKey(listener);
  });
  //return Medir;
}

w.CreateSelect = function(layer){
  var select = new Select({
    layers: [layer], /* w.GetLayerWithState("editando") */
    })

  return select;
}

w.CreateModify = function(FeaturesSource){
  var modify = new Modify({
    features: FeaturesSource.getFeatures(),
    })

  return modify;
}
//#endregion

//#region Zona De Controles de ZOOM, ROTATE, ZoomToExtent, ZoomOnReproject

//hace zoom al extent por defecto, exepto en la proyeccion stereographic polar
w.ZoomToDefaultExtent = function(Duration){
  if(typeof Duration !== 'number'){
    console.warn("No esta definida correctamente la duración de la rotación")
    Duration = 0;
  }
  /*  projection: w.GlobalDefaultMapView.projection,
  center: w.GlobalDefaultMapView.center,*/

  //if(GlobalMapView.getProjection().code_ != "EPSG:3031"){
    var localView = new View({
      projection: w.GlobalDefaultMapView.projection,
      center: w.GlobalDefaultMapView.center,
      zoom: w.GlobalDefaultMapView.zoom,
      minZoom: w.GlobalDefaultMapView.minZoom,
      maxZoom: w.GlobalDefaultMapView.maxZoom,
    })

    var newExtent = transformExtent(  localView.calculateExtent() , w.GlobalDefaultMapView.projection,  GlobalMapView.getProjection() )


    var newCenter = transform( w.GlobalDefaultMapView.center, w.GlobalDefaultMapView.projection, GlobalMapView.getProjection() )


    var newView = new View({
      center: w.GlobalDefaultMapView.center,
      projection: w.GlobalMapView.getProjection(),
    })

    newView.fit(newExtent);
    //new ZoomView =

    //w.map.getView().fit(w.map.getView().calculateExtent(map.getSize()));

    w.GlobalMapView.animate({
      zoom: newView.getZoom(),
      center: newCenter,
      rotation: 0,
      duration: Duration,
    });

  //}

}

//mantiene el zoom al cambiar de proyeccion, se puede animar o no
w.MantainZoomOnProyectionChange = function(originalRotatio, extent, projection, newProyection, Duration){
  if(typeof Duration !== 'number'){
    console.warn("No esta definida correctamente la duración de la rotación")
    Duration = 0;
  }
/*  projection: w.GlobalDefaultMapView.projection,
  center: w.GlobalDefaultMapView.center,*/
  // console.log("zoom = " + w.GlobalMapView.getZoom());

  var newExtent = transformExtent(extent, projection, newProyection)

  w.GlobalMapView.fit(newExtent);
  // console.log("zoom = " + w.GlobalMapView.getZoom());

  w.GlobalMapView.animate({
    rotation: originalRotatio,
    duration: Duration,
  });
}

//setea el mapa a la escala, ej 1:10.000 seria SetScaleOnMap(10000)
w.SetScaleOnMap = function(EscalaNueva){

  var ResolucionAnterior = w.GlobalMapView.getResolution()
  var EscalaActual = w.ScaleBar.getScaleForResolution()
  var ResolucionNueva = ( EscalaNueva / EscalaActual) * ResolucionAnterior

  // console.log("anterior: " + resolucionAnterior)
  // console.log("Nueva: " + resolucionNueva)

  w.GlobalMapView.setResolution(ResolucionNueva)
}

w.SetScaleOnOtherMap = function(EscalaNueva, map){

  var ResolucionAnterior = w.GlobalMapView.getResolution()
  var EscalaActual = w.ScaleBar.getScaleForResolution()
  var ResolucionNueva = ( EscalaNueva / EscalaActual) * ResolucionAnterior

  // console.log("anterior: " + resolucionAnterior)
  // console.log("Nueva: " + resolucionNueva)

  w.GlobalMapView.setResolution(ResolucionNueva)
}

//agrega o quita zoom animado
w.ZoomView = function(ZoomString, ZoomValue, Duration){
  //calculo llos grados en radianes de la rotacion
  var ZoomDirection = 1;
  //decido la direccion
  switch(ZoomString.toLowerCase()){
    case "+":
      ZoomDirection = 1;
      break;
    case "adentro":
      ZoomDirection = 1;
    break;
    case "zoomin":
      ZoomDirection = 1;
    break;
    case "-":
      ZoomDirection = -1;
    break;
    case "afuera":
      ZoomDirection = -1;
    break;
    case "zoomout":
      ZoomDirection = -1;
    break;

    default:
      RotationString = ""
      break;
  }

  if(typeof Duration !== 'number'){
    console.warn("No esta definida correctamente la duración de la rotación")
    Duration = 0;
  }

  //generamos la animacion con los datos calculados/obtenidos
  if(typeof ZoomValue === 'number'){
    if(ZoomString != ""){
      w.GlobalMapView.animate({
        zoom:  w.GlobalMapView.getZoom() + (ZoomValue * ZoomDirection),
        duration: Duration,
      });
    }else{
      console.warn("No esta definida la dirección del zoom")
    }
  }else{
    console.warn("No esta definida o no es correcta la cantidad de zoom")
  }

}

//rota la vista del mapa una cantidad de grados determinados y en una
//cantidad de tiempo determinado, ademas decidiendo si es horario o no
w.RotateViwe = function(RotationString, Grados, Duration){
  //calculo llos grados en radianes de la rotacion
  var RotationAngle = 180/Grados;
  var RotationDirection = 1;
  //decido la direccion
  switch(RotationString.toLowerCase()){
    case "horario":
        RotationDirection = 1;
      break;
    case "derecha":
      RotationDirection = 1;
    break;
    case "der":
      RotationDirection = 1;
    break;
    case "antihorario":
      RotationDirection = -1;
    break;
    case "izquierda":
      RotationDirection = -1;
    break;
    case "izq":
      RotationDirection = -1;
    break;

    default:
      RotationString = ""
      break;
  }

  if(typeof Duration !== 'number'){
    console.warn("No esta definida correctamente la duración de la rotación")
    Duration = 0;
  }

  //generamos la animacion con los datos calculados/obtenidos
  if(typeof Grados === 'number'){
    if(RotationString != ""){
      w.GlobalMapView.animate({
        rotation:  w.GlobalMapView.getRotation() + ((Math.PI / RotationAngle) * RotationDirection),
        duration: Duration,
      });
    }else{
      console.warn("No esta definida la dirección de la rotación")
    }
  }else{
    console.warn("No esta definida o no es correcto el valor de la variable Grados")
  }

}

w.scaleBarAndroidVersion = function(){
  scaleControl("Android");
}

//#endregion

//#region ZONA RE PROYECCION (REPROJECT)

  //re projecta la vista y cambia el sistema de referencias
  //para capturar las cordenadas del mouse
  w.setProjectionOnMap = function( Projection ){
    //seteo el sistema de proyeccion para el mouse
    w.mousePositionControl.setProjection(Projection);
    //obtengo los datos del sistema de proyeccion y reproyecto
    searchAndReProject(Projection);
    //si la proyeccion es geografica le cambio la presicion
    //a los numeros de las coordenadas del mouse para 6
    //lugares despues de la coma
    if( Projection == "EPSG:4326"){
      w.unidadesDeLaProyeccion = "gms";
      w.mousePositionControl.setCoordinateFormat(createStringXY(6))
    }else{
      w.unidadesDeLaProyeccion = "km_adaptive";
      w.mousePositionControl.setCoordinateFormat(createStringXY(0))
    }
  }

  w.GetActualExtent = function(CRS_To_Transform){
    let finalExtent = undefined;
    let mapExtent = w.map.getView().calculateExtent(w.map.getSize());
    let mapCRS =  w.map.getView().getProjection().getCode();

    if(CRS_To_Transform != undefined){
      ExtentCalculated = transformExtent(mapExtent, mapCRS, CRS_To_Transform);

      finalExtent = new BoundingBox(
        CRS_To_Transform,
        ExtentCalculated[0],
        ExtentCalculated[1],
        ExtentCalculated[2],
        ExtentCalculated[3]
      );

    }else{
      finalExtent = new BoundingBox(
        mapCRS,
        mapExtent[0],
        mapExtent[1],
        mapExtent[2],
        mapExtent[3]
      );
    }

    return finalExtent
  }
//#region SEARCH AND REPROJECT (busca la proyeccion y si existe la setea con los datos conseguidos)
//esta funcion chequea que la projeccion que se le da para buscar
//funciona y llama la funcion que reproyecta
function searchAndReProject2(EPSGCode) {
  //me quedo con solo el numero del EPSG
  var query = EPSGCode.split(":")[1];
  //resultSpan.innerHTML = 'Searching ...';
  fetch('https://epsg.io/?format=json&q=' + query)
    .then(function (response) {
      return response.json();
    })
    .then(function (json) {
      var results = json['results'];
      if (results && results.length > 0) {
        for (var i = 0, ii = results.length; i < ii; i++) {
          var result = results[i];
          if (result) {
            var code = result['code'];
            var name = result['name'];
            var proj4def = result['proj4'];
            var bbox = result['bbox'];
            if (
              code &&
              code.length > 0 &&
              proj4def &&
              proj4def.length > 0 &&
              bbox &&
              bbox.length == 4
            ) {
              setProjection(code, name, proj4def, bbox);
              return;
            }
          }
        }
      }
      setProjection(null, null, null, null);
    });
}

async function searchAndReProject(epsgCode) {
  const code = epsgCode.split(':')[1];          // 3031
  const url  = `https://cdn.jsdelivr.net/npm/epsg-index/s/${code}.json`;

  try {
    const json   = await fetch(url).then(r => r.json());
    if (json && json.proj4) {
      setProjection(json.code, json.name, json.proj4, json.bbox);
    } else {
      setProjection(null, null, null, null);
    }
  } catch (err) {
    console.error('Error al buscar EPSG', err);
    setProjection(null, null, null, null);
  }
}
//#endregion



//#region SET PROJECTION
  //esta funcion se encarga de reprojectar
  function setProjection(code, name, proj4def, bbox) {

    if (code === null || name === null || proj4def === null || bbox === null) {
      //resultSpan.innerHTML = 'Nothing usable found, using EPSG:3857...';
      w.map.setView(
        new View({
          projection: 'EPSG:3857',
          center: [-6300000, -3850000],
          zoom: 6.8,
        })
      );
      return;
    }
    //resultSpan.innerHTML = '(' + code + ') ' + name;

    var newProjCode = 'EPSG:' + code;
    proj4.defs(newProjCode, proj4def);
    register(proj4);

    var newProj = getProjection(newProjCode);
    var fromLonLat = getTransform('EPSG:4326', newProj);

    var worldExtent = [bbox[1], bbox[2], bbox[3], bbox[0]];
    w.ActualProjectionWorldExtent = worldExtent;
    newProj.setWorldExtent(worldExtent);

    // approximate calculation of projection extent,
    // checking if the world extent crosses the dateline
    if (bbox[1] > bbox[3]) {
      worldExtent = [bbox[1], bbox[2], bbox[3] + 360, bbox[0]];
    }
    var extent = applyTransform(worldExtent, fromLonLat, undefined, 8);

    var originalRotation = w.GlobalMapView.getRotation();
    // var extent = w.map.getExtent();
    var extencion = w.map.getView().calculateExtent(w.map.getSize())
    // console.log(extent);
    var projection = w.GlobalMapView.getProjection();
    var newProyection = newProj
    var Duration = 0;

    newProj.setExtent(extent);
      w.GlobalMapView = new View({
      projection: newProj,
    });
    w.map.setView(w.GlobalMapView);
    w.GlobalMapView.fit(extent);
    //if(newProjCode != "EPSG:3031"){
      w.MantainZoomOnProyectionChange(originalRotation, extencion, projection, newProyection, Duration);
    //}
  }
//#endregion

//#endregion

//#region TEST ZOOM TO LAST LAYER Trata de hacer zoom a la Layer asta que logre detectar los datos vectoreales

  //esto es para hacer un bucle y chequear cuando el zoom to layer es posible
  function Test_ZoomToLastLayer(LayerToZoom, bucle, retraso){
    // console.log( "bucle " + bucle );
    if((LayerToZoom.getSource().getExtent()[0] == "Infinity") == false){
      //console.log( "se hicieron " + (bucle + 1) + " bucles, (" + ((bucle + 1) * retraso) + "ms)" );
      // w.ZoomToLayer(w.map.getLayers().getArray().length-1);
      w.ZoomToLayer(layersDelMapa.Lista[0]);
    }else{
      setTimeout(function(){
        // console.log( "inicia bucle testGetExtent 2" );
        Test_ZoomToLastLayer_ReBucle(LayerToZoom, bucle+1, retraso)
      }, retraso)
    }
  }

  //esto es para hacer un bucle y chequear cuando el zoom to layer es posible
  function Test_ZoomToLastLayer_ReBucle(LayerToZoom, bucle, retraso){
    // console.log( "bucle" + bucle );
    if((LayerToZoom.getSource().getExtent()[0] == "Infinity") == false){
      //console.log( "se hicieron " + (bucle + 1) + " bucles, (" + ((bucle + 1) * retraso) + "ms)" );
      // w.ZoomToLayer(w.map.getLayers().getArray().length-1);
      w.ZoomToLayer(layersDelMapa.Lista[0]);
    }else{
      setTimeout(function(){
        // console.log( "inicia bucle testGetExtent" );
        Test_ZoomToLastLayer(LayerToZoom, bucle+1, retraso)
      }, retraso)
    }
  }

//#endregion

//#region  INSTANCIANDO MAPA

//#region CAPAS POR DEFECTO HARD CODEADAS

  //#region CAPA BASE DE OPEN STREET MAP
  w.OpenStreetMap_OSM = new TileLayer({
    className: w.GlobarlLayerOLNumberName,
    preload: Infinity,
    zIndex: 0,
    // [minx, miny, maxx, maxy].
    // para setear una extencion deberia ser extent: transformExtent([xmin,ymin,xmax,ymax], SistemaDeCoordenadas, SistemaCoordenadasDestino)
    // extent: transformExtent([-58.5,-35,-53,-30], 'CRS:84', 'EPSG:3857'),
    source: new OSM(),
  });

  OpenStreetMap_OSM.OriginalName = "Open Street Map";

  // OpenStreetMap_OSM

  //subimos el contador de nombre, necesario para que todas las capas tengan nombre unico
  w.GlobarlLayerOLNumberName++;
  //#endregion

//#endregion

//#region MAP CUSTOME CONTROLS

  //#region MOUSE POSITION COORDENATES CONTROL
  //esto es un control usado para capturar las caoordenadas del mouse
  w.mousePositionControl = new MousePosition({
    coordinateFormat: createStringXY(0),
    projection: 'EPSG:3857',
    // comment the following two lines to have the mouse position
    // be placed within the map.
    className: 'custom-mouse-position',
    target: document.getElementById("BI_CoordenadasXYInternas"),
    undefinedHTML: 'Z',
  });

  var rotate = new RotateControl({
    target: document.getElementById("ScaleBar_Container"),
    autoHide:false,
    label:document.getElementById("Norte"),
    tipLabel:"Resetear Rotación"
  })
  //#endregion

  function ChangeNorthAngle(){
    //console.log(['--NRotation', (-1 * w.map.getView().getRotation()) + "deg"]);
    document.documentElement.style.setProperty('--NRotation', (-1 * (w.map.getView().getRotation() * 180/Math.PI)) + "deg");
  }

  //#region ATTRIBUTION TARGET HTML ELEMENT elemento para las atributions
  var attribution = new Attribution({
    target:  document.getElementById("ActiveZone"),
    collapsible: true,
  });
  //#endregion

  //#region ZOOM SLIDER
  //zoomslider necesario para la barra de zoom y refrescarla
  var zoomslider = null;

  function refreshZoomSlider(){
    if(zoomslider != null){
      w.map.removeControl(zoomslider);
    }
    zoomslider = new ZoomSlider({
    });
    zoomslider.setTarget(document.getElementsByClassName("Zoom_Slider_Container")[0]);
    w.map.addControl(zoomslider);

  }
  //#endregion

  //#region SCALE BAR
//guardo en una variable donde se va a colocar la barra de escala
var targetScaleBar = document.getElementById("ScaleBar_Container");

//Creo el elemento de la barra de escala
w.ScaleBar = new ScaleLine({
  units: "metric",
  target: "ScaleBar_Container",
});

//este es el objeto que guardara los datos de la barra de escala
w.ScaleBarData = class ScaleBarData {
  constructor(scaleType, scaleBarSteps, scaleBarText, unitsSelect) {
    this.scaleType = scaleType;
    this.scaleBarSteps = scaleBarSteps;
    this.scaleBarText = scaleBarText;
    this.unitsSelect = unitsSelect;
  }
} //END Class ScaleBarData

//esto son los datos de la barra de escala por defecto
//#region Datos de la Barra de escala
w.ScaleBarData.scaleType = 'scalebar';
w.ScaleBarData.scaleBarSteps = 4;
w.ScaleBarData.scaleBarText = true;
w.ScaleBarData.unitsSelect = "metric";
//#endregion

//segun si es mobil o no se setea la barra de escala correcta
function scaleControl(Plataform) {
  var minWidthOriginal = 140;
  w.map.removeControl(w.ScaleBar);
  if(Plataform == "Android"){
    minWidthOriginal = 75;
  }

  if (w.ScaleBarData.scaleType === 'scaleline') {
    w.ScaleBar = new ScaleLine({
      units: w.ScaleBarData.unitsSelect,
      target: "ScaleBar_Container",
    });
    return;
  }
  w.ScaleBar = new ScaleLine({
    units: w.ScaleBarData.unitsSelect,
    bar: true,
    steps: w.ScaleBarData.scaleBarSteps,
    text: w.ScaleBarData.scaleBarText,
    minWidth: minWidthOriginal,
    target: "ScaleBar_Container",
  });
  //w.map.removeControl(w.ScaleBar);
  w.map.addControl(w.ScaleBar);

  return;
}// END scaleControl(Plataform)
//#endregion

//#endregion

//#region GLOBAL MAP VIEW CLASS (clase de la vew por defecto del mapa)
w.GlobalMapView = new View({
  projection: w.GlobalDefaultMapView.projection,
  center: w.GlobalDefaultMapView.center,
  zoom: w.GlobalDefaultMapView.zoom,
  minZoom: w.GlobalDefaultMapView.minZoom,
  maxZoom: w.GlobalDefaultMapView.maxZoom
});
//#endregion

//#region DRAG AND DROP PARA CARGAR CAPAS
//interaccion necesaria para el drag and drop
var dragAndDropInteraction = new DragAndDrop({
  formatConstructors: [GPX, GeoJSON, IGC, KML, TopoJSON],
});

//Evento Drag and Drop
//PARA AGREGAR CAPAS EN EL MAPA AL HACER DRAG AND DROP
dragAndDropInteraction.on('addfeatures', function (event) {

  //guardo el nimero de la ultima capa existente en el mapa
  var lastLayerNumber = (w.map.getLayers().getArray().length)-1;
  //Guardo el nombre del archivo que se dropeo
  var file_name = event.file.name;

  var vectorSource = new VectorSource({
    features: event.features,
  });

  //se agrega la capa con origen e datos
  w.map.addLayer(
    new VectorImageLayer({
      className: w.GlobarlLayerOLNumberName,
      zIndex: w.map.getLayers().getArray().length *-1,
      source: vectorSource,
    })
  );

  //subimos el contador de nombre
  w.GlobarlLayerOLNumberName++;

  var metadato = {
    Origen: file_name,
  }

  let descriptionString =
  `
    <div>
      <span class="W_Layer_NOT_Loaded"> - Capa editable</span>
      <br />
      <span>Capa de geometría subida por el usuario desde archivo.</span>
    </div>
  `

  //o agrego a mi lista de features LayerData(ZDepth, Visible, Nombre, Formato, OpenLayerSource, Listado, Opacacity, capapordefecto)
  var layerToAdd = new LayerData({
    //datos de la layer a agregar
      //zDepth: w.map.getLayers().getArray().length -1,
      Visible: true,
      Nombre: file_name.split('.')[0],
      Description: descriptionString,
      Formato: file_name.split('.')[1].toUpperCase(),
      OpenLayerSource: w.map.getLayers().getArray()[lastLayerNumber + 1],
      Listado: false,
      Opacacity: 1,
      CapaPreCargada: false,
      Metadata: metadato,
      EstadoDeLaCapa: "",
      CapaDescargable: true,
      Attributions: "",
    });

    layerToAdd.OpenLayerSource.OriginalName = file_name.split('.')[0];


  //#region agregando Capa al Mapa y seteando Hud Element
    //agrego la capa al mapa (agrega la LayerData a la lista de capas)
    w.layersDelMapa.AddLayerToMap( layerToAdd );
    //creo el elemento HTML para la ultima capa creada
    w.layersDelMapaGUI.CreateHTMLElementForLayerData(layerToAdd)
    //actualizo los indices de las capas
    w.layersDelMapa.ActualizarZIndex()
    //actualizo las capas de la lista para mostrarlas todas
    w.layersDelMapaGUI.UpdateAllLayersOnGUI();
  //#endregion

  //enfoco la capa a la que cargue
  //investigar como bajar un poquito el zoom cuando se enfoca
  //la capa para que no quede tocando los bordes
  w.map.getView().fit( vectorSource.getExtent() );
});
//#endregion

//#region EVENT ON WINDOW RESIZE
  //hace que se dispare un evento cuando cambia el tamaño de la ventana
  //cambia refresca el tamaño de la zoomSlider

w.addEventListener('resize', function(){
  refreshZoomSlider();
});

//#endregion

//#region  EVENT ON Check If Scale Change
//evento que chequeará el cambio de escala
function CheckIfScaleChange(e){

  //la escala correcta, es retornada 1ms tarde, asi que hay que retrasar el analisis
  // setTimeout(function() {
  //  console.log(w.LastResolution + " != " +   w.map.getView().getResolution())
  //  console.log(w.LastsScale + " != " +   w.ScaleBar.getScaleForResolution());
  // }, 1);

  setTimeout(function() {

    if(w.LastsScale != w.ScaleBar.getScaleForResolution()){

      //esto hace que solo se active cuando la escala cambeie
      w.LastsScale = w.ScaleBar.getScaleForResolution()

      //si la ventana de imprimir esta prendida
      if(w.VentanaPrintPNG != undefined && w.VentanaPrintPNG != null){

        //el dropdown de la ventana
        var dropdown = w.VentanaPrintPNG.getElementsByClassName("W_ImputDropDown")[1]

        //esto hay que retrasarlo 1 milisegundo porque sino falla, y devuelve la escala incorrecta
        if( Math.round(ScaleBar.getScaleForResolution()) !=  dropdown.value){
          w.SetDropDownOptionByIndex(dropdown.id, 1)
        }

      }
    }
  }, 1);


}// END function CheckIfScaleChange
//#endregion

//#region DEBUG GET ACTUAL ZOOM
//evento para devolver el zoom del mapa cuando este se cambia
//de escala, actualmente desactivado
function onMoveEnd(evt) {
  console.log("ActualZoom = " + w.GetActualZoom())
}

//devuelve el zoom actual del mapa
w.GetActualZoom = function(){
  return w.map.getView().getZoom()
}
//#endregion

//#region esto pasa al clickear "CHECK FEATURE INFO"

//para poder cancelar las llamadas
w.CheckInfoTareaPendiente = 0;
var controller = new AbortController();
var {signal} = controller;

/** cancela las tareas pendientes de Check Feature Info
 * @param {AbortController} controller El Control que cancelara las tareas
 */
function CancelarTareasPendientes_CheckFeatureInfo(controller){
  // Abort request, se llama si hay tareas pendientes
  if(w.CheckInfoTareaPendiente > 0){
    // console.log("Hay " + w.CheckInfoTareaPendiente + " tareas pendiente")

    controller.abort();
    // console.log("Cancelada")

    //reseteo el contador
    w.CheckInfoTareaPendiente = 0;
  }
}

/** Genera la accion de Check info al cliquear en el mapa
 * @param {Map} mapa Mapa que se usara para hacer la consulta
*/
function CheckInformationOnClick(mapa){
  mapa.on('singleclick', function (evt) {

    var BS_Boton_PedirInfo =  document.getElementsByName("BS_Boton_PedirInfo")[0]
    var className = "M_Button_Selected"
    //w.CheckInformation == true

    if(  (' ' + BS_Boton_PedirInfo.className + ' ').indexOf(' ' + className + ' ') > -1 ){

      //creo la ventana con el mensaje ESPERE...
      w.CreateWindowFeatureInfo("ESPERE")

      //informacion del pixel donde se clickeo
      var pixel = w.map.getEventPixel(evt.originalEvent);

      //la resolucion que usa como referencia
      var viewResolution = /** @type {number} */ (w.map.getView().getResolution());

      //la lista de capas
      var Capas = w.map.getLayers().getArray();
      // console.log(Capas)

      //voy a comprobar capa a capa que capa pulse
      for(var capaActual = Capas.length-1; capaActual >= 0; capaActual-- ){

          //creo la variale donde alojo la capa a chequear, esto facilita el debug
          var capaAChequear = Capas[capaActual];
          var featureAChequear;

          //chequelo la colicion del pixel contra la capa actual a comprobar
          // var hit = window.map.forEachFeatureAtPixel(pixel, function (layer, param2){
          //     //so la capa clickeada "layer" es igual a la actual a revisar da true
          //     // if(layer == capaAChequear){
          //       console.log(layer)
          //       console.log(layer)
          //       capaAChequear = layer
          //         return true;
          //     // }else{
          //     //     return false;
          //     // }
          // });

          var layerDataAChequear = w.GetLayerWithOpenLayerSource(capaAChequear)

          // console.log("================================================");
          // console.log(w.GetLayerWithOpenLayerSource(capaAChequear).Nombre);
          // console.log(layerDataAChequear);
          // console.log(capaAChequear.getData(pixel));



          var hit;
          var hitVector;
          // console.log(OpenStreetMap_OSM)
          if(layerDataAChequear != OpenStreetMap_OSM){
            if(layerDataAChequear.Visible == true){
              hit = capaAChequear.getData(pixel)
              if(hit == null){
                //esto quiere decir que no es un wms, porque fue imposible detectar transparencia de pixel
                //posiblemente sea un vector, si no es un vector probablemente no sea nada o sea OSM
                hitVector = w.map.forEachFeatureAtPixel(pixel, function (feature, layer, poligon){
                  if(poligon != undefined){
                    //detecta si es vectorial la capa y si hay capa vectorial en primer lugar
                    if(capaAChequear == layer){
                      //si la capa es vectorial y es la que se esta chequeando
                      hit = true;
                      return true
                    }else{
                      //si la capa es vectorial pero no es la que se esta chequeando
                      hit = undefined;
                    }
                    return true
                  }
                });
              }else{
                if(hit[3] == 0){
                  hit = undefined;
                }
              }
            }
          }else{
            hit = undefined;
          }

          // console.log("hit: " + (hit));
          // console.log("hay contacto: " + (hit != undefined));
          // console.log("================================================");

          //si hit dio true, dejo de revisar hit y la tomo como la correcta
          if(hit != undefined){
            // console.log("se detecto hit contra " + w.GetLayerWithOpenLayerSource(capaAChequear).Nombre)
            //get LayerData from OL Layer
            var LayerDataSelected = w.GetLayerWithOpenLayerSource(capaAChequear)

            // console.log(LayerDataSelected);

            //hace debug del nombre de la capa seleccionada
            // console.log("seleccionada la capa " + LayerDataSelected.Nombre);

            if(LayerDataSelected.Formato.toLowerCase() == "wms"){

              //console.log("LayerDataSelected is wms")
              //creo la ventana vacia, esto se cambio asi para bajar la latencia
              w.CreateWindowFeatureInfo("WMS")

              //esta es la consulta que se va a realizar, es los datos en el pixel
              var url = Capas[capaActual].getSource().getFeatureInfoUrl(
                evt.coordinate,
                viewResolution,
                w.map.getView().getProjection(), //'EPSG:3857',
                {'INFO_FORMAT': 'text/html'}
              );

              if (url) {

                CancelarTareasPendientes_CheckFeatureInfo(controller)

                //cuento la tarea en el contador
                w.CheckInfoTareaPendiente += 1;
                controller = new AbortController();

                var {signal} = controller;

                //reviso el url
                fetch(url, {signal} )
                  //hago la consulta para que me devuelva el texto
                  .then(function (response) { return response.text(); }).catch(function(err) {
                    console.warn(`Err: Cancelando consultas anteriores para realizar la nueva...`);
                    //console.warn(` Err: ${err}`);
                  })
                  .then(function (html) {
                      //el html de resultado es imprimido en pantalla y en la consola
                        var parser = new DOMParser();
                        var xmlDoc = parser.parseFromString(html,"text/html");

                        //layers de resultado
                        var ResultLayers = []

                        // debug del docuemnto
                        // console.log(xmlDoc)

                        //trato de saber si es un WMS de Geoserver o de ArcGIS
                        if(xmlDoc.title == "Geoserver GetFeatureInfo output"){
                        //GEOSERVER
                          //listo las capas
                          var Capas = xmlDoc.getElementsByTagName('table')

                          //recorriendo las capas obtengo los nombres
                          for(var cActual = 0; cActual<Capas.length; cActual++){
                            //creo el elemento donde guardar los datos
                            ResultLayers.push(new ResultLayerGetInfo(undefined))

                            //relleno los datos
                            ResultLayers[cActual].Nombre = $(Capas[cActual].caption).text()
                            ResultLayers[cActual].Title = w.LayerDataGetTitleByName(ResultLayers[cActual].Nombre, LayerDataSelected)
                            ResultLayers[cActual].ServerType = "GeoServer"
                          }

                          //reviso las capas para llenar datos
                          for(var cActual = 0; cActual<Capas.length; cActual++){
                            //variables locales necesarioas
                            var fields = []
                            var values = []
                            //elementos listados
                            var TableFieldNames = Capas[cActual].getElementsByTagName('th')
                            var TableFieldValue = Capas[cActual].getElementsByTagName('td')

                            //reviso los fields de la capa actual
                            for(var fieldActual = 0; fieldActual<TableFieldNames.length; fieldActual++){
                                fields.push($(TableFieldNames[fieldActual]).text())
                                values.push($(TableFieldValue[fieldActual]).text())
                            }

                            //le asigno los fields y los valores
                            ResultLayers[cActual].Fields = fields
                            ResultLayers[cActual].Values = values
                          }

                        }else{
                        //ARCGIS

                          //listo las capas
                          var Capas = xmlDoc.getElementsByTagName('table')

                          //listo los h5 que son los nombres de capas
                          var h5DeCapas = xmlDoc.getElementsByTagName('h5')

                          //recorro los h5 para obtener los nombres
                          for(var cActual = 0; cActual<h5DeCapas.length; cActual++){
                            //creo el elemento donde guardar los datos
                            ResultLayers.push(new ResultLayerGetInfo(undefined))

                            //relleno los datos
                            ResultLayers[cActual].Nombre = $(h5DeCapas[cActual]).text().split("'")[1]
                            ResultLayers[cActual].Title = w.LayerDataGetTitleByName(ResultLayers[cActual].Nombre, LayerDataSelected);
                            ResultLayers[cActual].ServerType = "ArcGIS Server"
                          }

                          //reviso las capas para llenar datos
                          for(var cActual = 0; cActual<Capas.length; cActual++){
                            //variables locales necesarioas
                            var fields = []
                            var values = []
                            //elementos listados
                            var TableFieldNames = Capas[cActual].getElementsByTagName('th')
                            var TableFieldValue = Capas[cActual].getElementsByTagName('td')

                            //reviso los fields de la capa actual
                            for(var fieldActual = 0; fieldActual<TableFieldNames.length; fieldActual++){
                                fields.push($(TableFieldNames[fieldActual]).text())
                                values.push($(TableFieldValue[fieldActual]).text())
                            }

                            //le asigno los fields y los valores
                            ResultLayers[cActual].Fields = fields
                            ResultLayers[cActual].Values = values
                          }

                        }

                        // console.log(ResultLayers)
                        // w.CreateWindowFeatureInfo(ResultLayers)

                        //se rellena la ventana con los datos
                        if(ResultLayers.length > 0){
                          w.ShowFeatureInfoResults(ResultLayers, LayerDataSelected)
                          CenterWindowIfNotMoved(VentanaComprobarInformacion);
                          w.CheckInfoTareaPendiente = 0;
                        }else{
                          w.CreateWindowFeatureInfo("SIN RESULTADOS")
                          CenterWindowIfNotMoved(VentanaComprobarInformacion);
                          w.CheckInfoTareaPendiente = 0;
                        }
                        // w.CheckInfoTareaPendiente -= 1;
                        return;

                    }).catch(function(err) {
                      console.warn(`Err: Cancelando consultas anteriores para realizar la nueva...`);
                  });
                  capaActual = -1;

               } //if (url)

            }else{

              // Abort request, se llama si hay tareas pendientes
              CancelarTareasPendientes_CheckFeatureInfo(controller)

              //cuento la tarea en el contador
              w.CheckInfoTareaPendiente += 1;
              controller = new AbortController();

              var {signal} = controller;

              //KML, GeoJSON, JSON, OL
              if(LayerDataSelected.Formato.toLowerCase() == "kml" || LayerDataSelected.Formato.toLowerCase() == "ol" || LayerDataSelected.Formato.toLowerCase() == "geojson" || LayerDataSelected.Formato.toLowerCase() == "json"){
                //creo la ventana
                w.CreateWindowFeatureInfo("OL")
                CenterWindowIfNotMoved(VentanaComprobarInformacion);

                //esto muestra el pixel en consola, solo para debug
                // console.log(evt.pixel)

                //obtengo el elemento de la capa que se encuentra en el pixel del click.
                var elementoSeleccionado = LayerDataSelected.OpenLayerSource.getFeatures(evt.pixel)

                //esto muestra el elementoSeleccionado en consola, solo para debug
                // console.log(elementoSeleccionado)

                //esta sera la lista donde se guardara el poligono seleccionado, los paso asi
                //y no solo el elemento para poder mantener la compatibilidad con mi codigo
                //de la ventana sin tener que cambiar nada
                var ResultLayers = []
                ResultLayers.push(new ResultLayerGetInfo(undefined))

                //le paso el nombre de la capa, el texto que saldra como "nombre de feature"
                //que como el mismo no tiene sentido es mejor usarlo para mostrar el mensaje
                //"Geometría seleccionada" y por ultimo me guardo el formato como "OL"
                ResultLayers[0].Nombre = LayerDataSelected.Nombre
                ResultLayers[0].Title = "Geometría seleccionado"
                ResultLayers[0].ServerType = "OL"

                //reviso el contenido de la promesa resultante de elemento seleccionado
                //este "debería" tener una "feature" adentro, pero nunca se llegara a este
                //punto sun una feature real seleccionada
                Promise.all([elementoSeleccionado]).then((Feature) => {
                  //muestra la feature seleccionada, solo con fines de debug
                  // console.log(Feature)

                  //aqi se obtienen los nombres de los campos
                  var KeyNames = Object.keys(Feature[0][0].values_)
                  var KeyValues = [] //aqui se guardaran los valores de los campos

                  //reviso los campos uno por uno para obtener el valor y ponerlo en la lista
                  for(var fieldActual = 0; fieldActual< KeyNames.length; fieldActual++){
                    //esto es para motrar la el nombre de la geometria correctamente
                    if(KeyNames[fieldActual] == "geometry"){
                      KeyValues.push( "" + Feature[0][0].values_[KeyNames[fieldActual]].constructor.name )
                    }else{
                      KeyValues.push( "" + Feature[0][0].values_[KeyNames[fieldActual]])
                    }
                  }

                  //agrego los resultados al objeto ResultLayerGetInfo de la lista ResultLayers
                  ResultLayers[0].Fields = KeyNames
                  ResultLayers[0].Values = KeyValues

                  //muestra el contenido de los objetos ResultLayerGetInfo de la lista ResultLayers, solo para debug
                  // console.log(ResultLayers)

                  //disparo la funcion que actualiza la ventana con los resultados (arrayResults, LayerDataSeleccionada)
                  w.ShowFeatureInfoResults(ResultLayers, LayerDataSelected)
                  CenterWindowIfNotMoved(VentanaComprobarInformacion);
                  w.CheckInfoTareaPendiente = 0;
                }).catch(function(err) {
                  // console.error("Error : " + err)
                  w.CreateWindowFeatureInfo("ERROR GEOMETRIA")
                  CenterWindowIfNotMoved(VentanaComprobarInformacion);
                  w.CheckInfoTareaPendiente = 0;
                });

                return;
              }else{

                  // Abort request, se llama si hay tareas pendientes
                  CancelarTareasPendientes_CheckFeatureInfo(controller)

                  //cuento la tarea en el contador
                  w.CheckInfoTareaPendiente += 1;
                  controller = new AbortController();

                  var {signal} = controller;

                  w.CreateWindowFeatureInfo("OSM")
                  CenterWindowIfNotMoved(VentanaComprobarInformacion);
                  w.CheckInfoTareaPendiente = 0;
                  return;
              }
            } // if WMS

          }else{

            // Abort request, se llama si hay tareas pendientes
            CancelarTareasPendientes_CheckFeatureInfo(controller)

            //cuento la tarea en el contador
            w.CheckInfoTareaPendiente += 1;
            controller = new AbortController();

            var {signal} = controller;

            w.CreateWindowFeatureInfo("VACIO")
            CenterWindowIfNotMoved(VentanaComprobarInformacion);
            w.CheckInfoTareaPendiente = 0;
          }//if(hit){...

      }// for(var capaActual...

    }else{
      // console.log("BS_Boton_PedirInfo is NOT selected")
    }// if(w.CheckInformation == true)

  }); // mapa.on('singleclick', function (evt)
} //function CheckInformationOnClick(mapa)

//#endregion

//#region INSTANCIAR MAPA

//inicializa el mapa

function InstanciarMapa( ){
  console.warn(" > Inicializando mapa...");
  w.map = new Map({
    controls: defaultControls({zoom:false, attribution: false, rotate: false}).extend([w.mousePositionControl, w.ScaleBar]),
    interactions: defaultInteractions().extend([dragAndDropInteraction]), // necesario para poder cargar capas desde afuera cn drag and drop//
    layers: [w.OpenStreetMap_OSM], //, AreaAdministrativa_IGM_ArcGIS, MontevideoIDE_GeoServer //otras capas que eran para testing
    target: 'map',
    view: w.GlobalMapView,
    // pixelRatio: 0.5,
  });
  console.warn("   > mapa Listo");

  //w.ZoomToDefaultExtent(200);

  //esto se usa cuando moves el mouse para detectar si hay features que pulsar
  w.map.on('pointermove', function (evt) {
    w.ActualizarCoordenadasMouse();
    if (evt.dragging) {
        return;
    }
    //tomo el pixel donde esta el mouse
    var pixel = w.map.getEventPixel(evt.originalEvent);

    //ejecuto una comprobacion de colsion entre el pixel y las layers
    var hit = window.map.forEachFeatureAtPixel(pixel, function (layer, rgba){
        return true;
    });

    //cambia el cursor si hit devuelve true, osea si hay una feature bajo el mouse
    //map.getTargetElement().style.cursor = hit ? 'pointer' : '';

  });


  //w.SetDropDownOptionByIndex

  //seteo la primera resolucion a mano
  w.LastResolution = w.map.getView().getResolution();
  //seteo la escala en una variable global
  w.LastsScale = 0;

  //seteo el evento que va a chequear el cambio de resolucion
  w.map.on('moveend', function(e){
    CheckIfScaleChange(e);
    ChangeNorthAngle();

  });

  w.map.on('postrender', function(e){
    ChangeNorthAngle();
  });

  CheckInformationOnClick(w.map)

  //#region evento move end para debuguear la escala, actualmente desactivado
    //evento para mostrar en consola el zoom
    //cuando se termina de mover el mapa
    //map.on('moveend', onMoveEnd);
  //#endregion

  //funcion para que se refresque la zoomslider para adaptarse al tamaño de la ventana
  refreshZoomSlider();
  //funcion que refresca la barra de scala para que se adapte con el dispositivo
  scaleControl();

  w.map.addControl(rotate);

  let descriptionString =
  `
    <div>
      <span class="W_Layer_NOT_Loaded">Capa cargada por defecto en el visualizador SIGAUy.</span>
      <br />
      <span>Mapa base de Open Street Map, tiene datos cartográficos de todo el mundo.</span>
    </div>
  `

  //la agrego a la lista de layers
  var layerToAdd = new LayerData({
    //datos de la layer a agregar
      Visible: true,
      Nombre: "Open Street Map (World Map)",
      Description: descriptionString,
      Formato: "BaseMap",
      OpenLayerSource: w.map.getLayers().getArray()[0],
      Listado: false,
      Opacacity: 1,
      CapaPreCargada: true,
      Metadata: {Origen:"Open street map"},
      EstadoDeLaCapa: "",
      CapaDescargable: false,
      Attributions: ["https://www.openstreetmap.org/copyright", "© OpenStreetMap"],
    });

  //#region agregando Capa al Mapa y seteando Hud Element
  //agrego la capa al mapa (agrega la LayerData a la lista de capas)
  w.layersDelMapa.AddLayerToMap( layerToAdd );
  //creo el elemento HTML para la ultima capa creada
  w.layersDelMapaGUI.CreateHTMLElementForLayerData(w.layersDelMapa.Lista[w.layersDelMapa.Lista.length-1])
  //actualizo los indices de las capas
  w.layersDelMapa.ActualizarZIndex()

  layerToAdd.GUILayer.getElementsByClassName("LE_Checkbox_Container")[0].click();
  //#endregion

  w.SourceDeLaLayerParaMedir = new VectorSource({
  });

  w.LayerParaMedir = new VectorLayer({
    className: w.GlobarlLayerOLNumberName,
    zIndex: 1000,
    source: w.SourceDeLaLayerParaMedir,
    style: new Style({
      fill: new Fill({
        color: 'rgba(255, 255, 255, 0.2)',
      }),
      stroke: new Stroke({
        color: '#ffcc33',
        width: 2,
      }),
      image: new CircleStyle({
        radius: 7,
        fill: new Fill({
          color: '#ffcc33',
        }),
      }),
    }),
  });

  //subimos el contador de nombre
  w.GlobarlLayerOLNumberName++;
  w.map.addLayer(w.LayerParaMedir);
  w.LayerParaMedir.OriginalName = "Layer Para Medir";
  console.warn("   > configuracion del mapa Listo");
}
//#endregion

//#endregion

//en esta variable se encuentran los valores de ancho y alto de la impresion
var canvasSize = {width:0, height: 0}
var aElement = 0;

//sleeciona los bloques que no se quieren y devuelven false
function EliminarBloqueos(e){
  w.CambiarPorcentajeExportarMapa(65);
}

//esta funcion se llama cuando se imprimern los controles
function SetScaleBarPosition(e){
  w.CambiarPorcentajeExportarMapa(80);
  // //selecciono los divs que pueden joder el posicionamiento y son innecesarios
  // var Tips = e.getElementById("tips");

  // //los borro
  // Tips.remove()

  //cambio ciertos estilos para poder desactivar ciertos simbolos css
  e.getElementById("OLControlsCSS").disabled = true;  //"OLControlsCSS"
  e.getElementById("PrintSetings").disabled = false;

  //escondo ciertos elementos que saldrian en la impresion en caso contrario
  e.getElementById("Zoom_Buttons_Container").style.opacity = 0
  e.getElementById("Zoom_Slider_Container").style.opacity = 0
  e.getElementById("MinimizedZone").style.opacity = 0

  //el contenedor de los controles Escala y Norte
  var ContenedorBarraDeEscala = e.getElementById("ScaleBarForPrint")

  //coloco la barra de escala
  ContenedorBarraDeEscala.appendChild(e.getElementById("ScaleBar_Container").childNodes[0])

  //coloco el norte
  ContenedorBarraDeEscala.appendChild(e.getElementById("ScaleBar_Container").childNodes[0])

  var BarraDeEscala = e.getElementsByClassName("ol-scale-bar ol-unselectable")[0]
  var norte = e.getElementsByClassName("ol-rotate ol-unselectable ol-control")[0]

  BarraDeEscala.style.left = 0 + "px"

  //esto es para centrar el norte contra la barra de escala
  var AnchoBarraDeEscala = $(BarraDeEscala.childNodes[0]).width();
  var AnchoNorte = $(norte).width();
  norte.style.left = ((AnchoBarraDeEscala/2) + ((AnchoNorte/2)*-1)) + "px";

  //le seteo el tamaño a la oja de impresion
  var ElementosImprimibles = e.getElementById("PrintableElements")
  ElementosImprimibles.className = "";
  ElementosImprimibles.style = "width:" + (canvasSize.width) + "px; height:" +  (canvasSize.height) + "px;"
  w.CambiarPorcentajeExportarMapa(85);
}

//codigo de Exportar imagen, no funciona aun
w.ImprimirPNG = function (NombreArchivoSalida, FormatoSalida, PosicionBarraEscala, PosicionNorte, InputScale) {
  //desactivo lo que se esta dibujando o midiendo
  document.getElementsByName("BS_Boton_Mano")[0].click();

  //console.log("ImprimirPNG(" + NombreArchivoSalida.textContent + ", " + FormatoSalida.value + ", " + PosicionBarraEscala.value + ", " + PosicionNorte.value + ", " + InputScale.textContent + ")")
  w.InputScaletextContent = InputScale.textContent;
  //el concepto es simple, se recorren las capas y se consigue un canvas con todo junto
  //luego por compatibilidad use la libreria html2canvas para re-renderizar el mapa
  //que me daba de salida lo de mas abajo para poder conseguir uno renderizado mas estandar
  //y al renderizarlo se lanza la funcion que renderiza la UI con el norte, la barra de escala
  //y el logo del geo, y lo renderiza sobre el canvaz que se re renderizo
  console.log("se va a imprimir")

  var ElementosImprimibles = document.getElementById("PrintableElements")
  //console.log(BarraDeEscala)

  //primero esperamos a que termine el renderizado y luego se guerda una copia de los canvas
  w.map.once('rendercomplete', function () {
    var mapCanvas = document.createElement('canvas');
    var size = w.map.getSize();
    // console.log("canvas [" + size[0] + "," + size[1] + "]");
    // console.log("viewport [" + $(w).width() + "," + $(w).height() + "]")
    mapCanvas.width = size[0];
    mapCanvas.height = size[1];

    canvasSize.width = size[0];
    canvasSize.height = size[1];

    w.CambiarPorcentajeExportarMapa(0);
    w.ExportActualState.childNodes[0].innerHTML = "<br>Preparando...";
    //w.CambiarPorcentajeExportarMapa(95);

    var cantidadCapas = document.getElementsByClassName("appContainer")[0].querySelectorAll('canvas').length;
    var cantidadActual = 0;

    //creo el canvas con las capas del mapa
    if(w.VentanaExportandoMapa != null){
      var mapContext = mapCanvas.getContext('2d');
      Array.prototype.forEach.call(
        document.getElementsByClassName("appContainer")[0].querySelectorAll('canvas'),
        function (canvas) {

          cantidadActual++;
          w.CambiarPorcentajeExportarMapa(0 + ((50/cantidadCapas)*cantidadActual));
          w.ExportActualState.childNodes[0].innerHTML = "<br>Renderizando capa " + cantidadActual +" de " + cantidadCapas + "";

          if (canvas.width > 0) {
            var opacity = canvas.parentNode.style.opacity;
            mapContext.globalAlpha = opacity === '' ? 1 : Number(opacity);
            var transform = canvas.style.transform;
            // Get the transform parameters from the style's transform matrix
            var matrix = transform
              .match(/^matrix\(([^\(]*)\)$/)[1]
              .split(',')
              .map(Number);
            // Apply the transform to the export map context
            CanvasRenderingContext2D.prototype.setTransform.apply(
              mapContext,
              matrix
            );
            mapContext.drawImage(canvas, 0, 0);
          }
        }
      );
    }

    w.CambiarPorcentajeExportarMapa(50);
    w.ExportActualState.childNodes[0].innerHTML = "<br>Renderizando capa " + cantidadActual +" de " + cantidadCapas + "";

    //w.SetScaleOnMap(w.InputScaletextContent)

    function imprimirEnMapa(UI, Mapa){

      html2canvas(UI,{
        backgroundColor:null,
        scale:1,
        // width: canvasSize.width,
        // height:  canvasSize.height,
        canvas:Mapa,
        onclone:SetScaleBarPosition,
        //removeContainer:false,
      }).then(function(canvasRendered2) {

        w.CambiarPorcentajeExportarMapa(95);
        w.ExportActualState.childNodes[0].innerHTML = "<br>Preparando Descarga...";

        var FormatoArchivo = ""
        var FormatoBlob = ""
        var quality = 1

        switch(FormatoSalida.value.toLowerCase()){
          case "png":
            FormatoArchivo = ".png";
            FormatoBlob = 'image/png';
            quality = 1;
            break

          case "jpeg":
            FormatoArchivo = ".jpg";
            FormatoBlob = 'image/jpeg';
            quality = 0.95;
            break

          case "jpeg2":
            FormatoArchivo = ".jpg";
            FormatoBlob = 'image/jpeg';
            quality = 0.8;
            break

          case "jpeg3":
            FormatoArchivo = ".jpg";
            FormatoBlob = 'image/jpeg';
            quality = 0.5;
            break
        }

        var NombreArchivoFinal = NombreArchivoSalida.textContent + FormatoArchivo;
        w.ExportActualState.childNodes[0].innerHTML = "<br>Mapa listo, Descargando...";
        //con este bloque voy a descargar la imagen impresa
        if(w.VentanaExportandoMapa != null){
          if (navigator.msSaveBlob) {
            // link download attribuute does not work on MS browsers
            navigator.msSaveBlob(canvasRendered2.msToBlob(FormatoBlob, quality), NombreArchivoFinal);
          } else {
            var link = document.getElementById('image-download');
            link.download = NombreArchivoFinal
            link.href = canvasRendered2.toDataURL( FormatoBlob, quality);
            link.click();
            w.CambiarPorcentajeExportarMapa(100);
            w.ExportActualState.childNodes[0].innerHTML = "<br>Mapa listo y Descargado";
            w.VentanaExportandoMapa.getElementsByClassName("W_button")[0].textContent = "Cerrar";
            setTimeout(function(){w.VentanaExportandoMapa.getElementsByClassName("W_button")[0].click()} , 800);
          }
        }

      });

    }

    //agrego el canvas a la pagina
    if(w.VentanaExportandoMapa != null){
      document.body.appendChild(mapCanvas)
    }

    if(w.VentanaExportandoMapa != null){
      html2canvas(mapCanvas,{
        backgroundColor:null,
        // width: canvasSize.width,
        // height:  canvasSize.height,
        // canvas:mapCanvas,
        onclone:EliminarBloqueos,
        // removeContainer:false,
      }).then(function(MapRenderedCanvas) {

        w.CambiarPorcentajeExportarMapa(75);
        w.ExportActualState.childNodes[0].innerHTML = "<br>Mapa listo Para Interface";


        //agrego el canvas resultante al documento html para poder
        //pasarlo denuevo por otro proceso de impresion
        document.body.appendChild(MapRenderedCanvas)

        //imprimo los controles sobre la version impresa del mapa
        if(w.VentanaExportandoMapa != null){
          w.ExportActualState.childNodes[0].innerHTML = "<br>Preparando Interface...";
          imprimirEnMapa(ElementosImprimibles, MapRenderedCanvas)
        }

        //elimino el canvas re impreso de la pagina
        MapRenderedCanvas.remove()

      });

      //elimino el canvas original de la pagina
      mapCanvas.remove()
    }
  });
  w.map.renderSync();
};

document.addEventListener('DOMContentLoaded', (e) => {
  w.JSON_OptionsRead(ConfigurationJSON);
});


